<template>
  <div id="appvue">
    <div class="wrapper">
      <div id="sidebar" :class="window.isDesktop ? 'sidebar' : 'sidebarpwa'">
        <div class="card" style="position: relative">
          <div style="position: sticky; top: 0; z-index: 1000">
            <div style="background-color: rgb(247, 247, 247)">
              <div class="card-header">
                {{ $t('mainMenu') }}
                <div style="float: right;">
                  <img @click="togglePanel" style="height: 25px; cursor: pointer;" :src="icons.closeIcon" />
                </div>
              </div>
            </div>
            <div style="background-color: white">
              <div class="mx-0 px-0 card-body">
                <ul class="nav nav-tabs" id="tabs" role="tablist">
                  <li class="nav-item">
                    <button class="nav-link active" data-bs-toggle="tab" data-bs-target="#tabtracks" type="button" role="tab">{{ $t('tracks') }}</button>
                  </li>
                  <li class="nav-item">
                    <button class="nav-link" data-bs-toggle="tab" data-bs-target="#tabsettings" type="button" role="tab">{{ $t('settings') }}</button>
                  </li>
                  <li class="nav-item">
                    <button class="nav-link" data-bs-toggle="tab" data-bs-target="#tabplaces" type="button" role="tab">{{ $t('objects') }}</button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div>
            <div class="tab-content" id="tab_content_tracks">
              <div class="tab-pane show active" role="tabpanel" id="tabtracks">
                <div class="card">
                  <div class="card-body p-2">
                    {{ $t('groupBy') }}:
                    <VueSelect style="display: inline-block; width: 200px; margin-bottom: 15px;" v-model="groupBy" :options="groups" :clearable="false" :searchable="false">
                    </VueSelect>
                    <br>
                    {{ $t('tracksSelected', [$store.getters.selectedTracks.length, $store.state.tracks.length]) }}<br>
                    {{ $t('tracksSelectedDistance') }}: {{ roundTrackDistance(sumTracksDistance($store.getters.selectedTracks)) }}
                    <ul>
                      <li v-if="countTracksByType($store.state.tracks, TrackType.walk) > 0">{{ $t('tracksSelectedDistanceWalk') }}: {{
                        roundTrackDistance(sumTracksDistanceWalk($store.getters.selectedTracks)) }}</li>
                      <li v-if="countTracksByType($store.state.tracks, TrackType.bicycle) > 0">{{ $t('tracksSelectedDistanceBicycle') }}: {{
                        roundTrackDistance(sumTracksDistanceBicycle($store.getters.selectedTracks)) }}</li>
                      <li v-if="countTracksByType($store.state.tracks, TrackType.mushroom) > 0">{{ $t('tracksSelectedDistanceMushroom') }}: {{
                        roundTrackDistance(sumTracksDistanceMushroom($store.getters.selectedTracks)) }}</li>
                    </ul>
                    <div style="font-size: 0.95rem">
                      <div v-if="$store.state.imports.length" class="mb-2">
                        <AppTrackGroup :searchText="''" :trackGroup="importGroup" :showDetails="true"></AppTrackGroup>
                      </div>
                      <input class="form-control mb-3" type="text" v-model="searchText" :placeholder="$t('search')" />
                      <div style="margin-bottom: 10px">
                        <button class="btn btn-primary btn-sm btn-nopadding" @click="showAllTracks">{{ $t('showAllTracks') }}</button>&nbsp;
                        <button class="btn btn-primary btn-sm btn-nopadding" @click="hideAllTracks">{{ $t('hideAllTracks') }}</button>&nbsp;
                        <button class="btn btn-primary btn-sm btn-nopadding" @click="expandAllGroups">{{ $t('expandAllGroups') }}</button>&nbsp;
                        <button class="btn btn-primary btn-sm btn-nopadding" @click="hideAllGroups">{{ $t('hideAllGroups') }}</button>&nbsp;
                      </div>
                      <div v-for="(trackGroupGroup, key) in trackGroupsDict" :key="key">
                        <div v-show="groupBy.id === key">
                          <div v-for="trackGroup in trackGroupGroup" :key="trackGroup.label" class="mb-2">
                            <AppTrackGroup :calendar="key == 'year'" :trackGroup="trackGroup" :searchText="searchText" :showDetails="true"></AppTrackGroup>
                          </div>
                        </div>
                      </div>
                    </div>
                    <button class="btn btn-primary btn-sm" @click="openImportFileInput">{{ $t('importGpxFile') }}</button>
                    &nbsp;
                    <button class="btn btn-primary btn-sm" v-if="!trailPhotosAdded" @click="openAddTrailPhotosInput">{{ $t('addTrailPhotos') }}</button>
                    <div v-else style="display:inline-block">
                      <button class="btn btn-danger btn-sm" @click="clearTrailPhotos">{{ $t('clearTrailPhotos') }}</button>&nbsp;
                      <button class="btn btn-success btn-sm" @click="openSaveTrailPhotos">{{ $t('saveTrailPhotos') }}</button>
                    </div>
                    <input ref="trailPhotosInput" id="trailPhotosInput" multiple type="file" style="display:none;" accept="image/jpeg" @change="importTrailPhotos" />
                  </div>
                </div>
              </div>
              <div class="tab-pane show" role="tabpanel" id="tabsettings">
                <div class="card">
                  <div class="card-body p-2">
                    <div class="card mb-2">
                      <div class="card-header py-2">
                        {{ $t('loginForm') }}
                      </div>
                      <div class="card-body p-2">
                        <div v-if="$store.state.user">
                          <form @submit.prevent="logOutFromApi" class="form-inline">
                            <div style="width: 100%" class="form-group flex-form-group">
                              <div style="width: 67%; display: flex; align-items: center;">
                                {{ $t('welcome') }}: {{ $store.state.user }}
                              </div>
                              <button style="width: 33%" type="submit" class="btn btn-primary">{{ $t('logOut') }}</button>
                            </div>
                          </form>
                        </div>
                        <div v-else>
                          <form @submit.prevent="logInToApi" class="form-inline">
                            <div style="width: 100%" class="form-group flex-form-group">
                              <input :disabled="loginInProgress" style="width: 33%" type="text" v-model="login" class="form-control me-2" :placeholder="$t('login')">
                              <input :disabled="loginInProgress" style="width: 33%" type="password" autocomplete="off" v-model="password" class="form-control me-2" :placeholder="$t('password')">
                              <button :disabled="loginInProgress" style="width: 33%" type="submit" class="btn btn-primary">
                                <img style='height: 16px; animation: rotation 2s infinite linear;' v-if="loginInProgress" :src="icons.spinnerWhite" />
                                <span v-else>{{ $t('logIn') }}</span>
                              </button>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                    {{ $t('language') }}:
                    <VueSelect v-model="language" :options="languages" :clearable="false" :searchable="false">
                      <template v-slot:option="option">
                        <span style='height: 13px' :class="'fi fi-' + option.flag"></span>
                        {{ option.label }}
                      </template>
                    </VueSelect>
                    <br>
                    {{ $t('playingSpeed') }}:
                    <img style="height: 20px;" :src="icons.bicycle" /> {{ $store.state.playingSpeed }} km/s&nbsp;&nbsp;
                    <img style="height: 20px;" :src="icons.shoe" /> {{ $store.state.playingSpeed / 10 }} km/s
                    <b-form-input style="width: 100%;" v-model="$store.state.playingSpeed" type="range" min="1" max="20"></b-form-input>
                    <b-form-checkbox :disabled="locationActive" class="display-inline marginright5" v-model="useHTML5location"></b-form-checkbox>
                    <span @click="toggleHTML5locationIfPossible">{{ $t('useHTML5location') }}</span><br>
                    
                    <b-form-checkbox class="display-inline marginright5" v-model="rotateDuringNavigation"></b-form-checkbox>
                    <span @click=" rotateDuringNavigation = !rotateDuringNavigation">{{ $t('rotateDuringNavigation') }}</span><br>
                    <div v-if="rotateDuringNavigation" style="display: flex; gap: 10px; width: 100%;">
                      <VueSelect style="width: 33%" v-model="rotateAngleThreshold" :options="rotateAngleThresholds" :clearable="false" :searchable="false"></VueSelect>
                      <VueSelect style="width: 33%" v-model="rotateMeterThreshold" :options="rotateMeterThresholds" :clearable="false" :searchable="false"></VueSelect>
                      <br>
                    </div>

                    <b-form-checkbox class="display-inline marginright5" v-model="largeButtonsDuringLocation"></b-form-checkbox>
                    <span @click="largeButtonsDuringLocation = !largeButtonsDuringLocation">{{ $t('largeButtonsDuringLocation') }}</span><br>
                    
                    <b-form-checkbox class="display-inline marginright5" v-model="showAllButtonsDuringLocation"></b-form-checkbox>
                    <span @click="showAllButtonsDuringLocation = !showAllButtonsDuringLocation">{{ $t('showAllButtonsDuringLocation') }}</span><br>
                    
                    <b-form-checkbox class="display-inline marginright5" v-model="lockPortrait"></b-form-checkbox>
                    <span @click="lockPortrait = !lockPortrait">{{ $t('lockPortrait') }}</span><br><br>

                    <div v-if="window.isDesktop">
                      {{ $t('speedScale') }}<br>
                      <div class="form-check">
                        <div v-for="(speedScale, sKey) of $store.state.speedScales" :key="sKey">
                          <input class="form-check-input" type="radio" name="speedScaleRadio" :id="'speedScaleChoose' + sKey" :value="sKey" v-model="speedScaleChoose">
                          <div style="background-color: white; margin: 2px">
                            <span v-for="(color, index) in speedScale.colors" :key="color.color"
                              :style="{ 'display': 'inline-block', 'font-size': '12px', 'text-align': 'center', 'color': 'white', 'width': '16px', 'height': '14px', 'margin': '1px', 'background-color': color.color }">
                              <b>{{ speedScale.thresholds[index] }}</b>
                            </span>
                          </div>
                        </div>
                      </div>
                      <br>
                    </div>




                    <div class="card mb-2">
                      <div class="card-header py-2">
                        {{ $t('uniformTrackColor') }}
                      </div>
                      <div class="card-body p-2">
                        <div>
                          <div id="uniformTrackColorPicker" :style="{ display: 'inline-block', width: '24px', height: '24px', borderRadius: '50%', backgroundColor: uniformTrackColorValue, border: '2px solid #ccc', cursor: 'pointer', verticalAlign: 'middle', marginRight: '8px' }"></div>
                          <b-popover target="uniformTrackColorPicker" triggers="focus" placement="top">
                            <SketchPicker
                              v-model="uniformTrackColor"
                              :presetColors="['#FF0000', '#09FF00', '#FF00E4', '#0037FF', '#00FFED', '#F6FF00', '#FFB600', '#007FFF', '#50006B', '#0C6E3D', '#9013FE', '#FE1378', '#9B9B9B', '#FFFFFF', '#000000', 'rgba(0, 0, 0, 0)']"
                              :disableAlpha="false"
                              :disableFields="true"></SketchPicker>
                          </b-popover>
                          <button class="btn btn-primary btn-sm" @click="applyUniformTrackColor">{{ $t('apply') }}</button>&nbsp;
                          <button class="btn btn-primary btn-sm" :disabled="!uniformTrackColorApplied" @click="restoreTrackColors">{{ $t('restore') }}</button>
                        </div>
                      </div>
                    </div>
                    <br>

                    <div class="card mb-2">
                      <div class="card-header py-2">
                        {{ $t('palette') }}
                      </div>
                      <div class="card-body p-2">
                        <div class="form-check">
                          <div v-for="palette of palettes" :key="palette">
                            <input class="form-check-input" type="radio" name="paletteRadio" :id="'paletteChoose' + palette" :value="palette" v-model="paletteChoose">{{ palette }}
                          </div>
                        </div>
                        Min: {{ paletteMin }}
                        <b-form-input style="width: 100%;" v-model.number="paletteMin" type="range" min="1" max="200" @update:model-value="adjustRangeMax"></b-form-input>
                        Max: {{ paletteMax }}
                        <b-form-input style="width: 100%;" v-model.number="paletteMax" type="range" min="1" max="200" @update:model-value="adjustRangeMin"></b-form-input>
                        Opacity: {{ binaryLayerAlpha }}
                        <b-form-input style="width: 100%;" v-model.number="binaryLayerAlpha" type="range" min="0" max="255"></b-form-input>
                      </div>
                    </div>






                    <br>
                    <OfflineCard v-if="window.mainmap"></OfflineCard>
                    <br>
                    <DebugCard></DebugCard>
                    <br>
                    <VisitedTilesCard></VisitedTilesCard>
                    <br>
                    <ContourCard></ContourCard>
                  </div>
                </div>
              </div>
              <div class="tab-pane show" role="tabpanel" id="tabplaces">
                <div class="card">
                  <div class="card-body p-2">
                    <ObjectsTab></ObjectsTab>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content">
        <div id="main_gallery_div" style="height: 100vh; overflow-y: scroll">
          <div style="position: sticky; top: 0; background-color: rgb(247, 247, 247)">
            <div class="card">
              <div class="card-header">
                {{ $t('galleries') }}
                <div style="float: right;">
                  <img @click="toggleGalleryPanel" style="height: 20px; cursor: pointer;" :src="icons.closeIcon" />
                </div>
                <div style="float: right; margin-right: 10px;">
                  <img style="width: 20px; height: 20px; cursor: pointer;" @click="toggleFullScreen" :src="fullscreenOpened ? icons.exitFullScreen : icons.enterFullScreen">
                </div>
                <div style="float: right; width: 50%; max-width: 200px; margin-right: 10px;">
                  <b-form-input style="width: 100%;" v-model="imagesInRow" type="range" min="1" max="10"></b-form-input>
                </div>
              </div>
            </div>
          </div>
          <div id="mainGalleryPhotos" v-if="mainGalleryOpened" style="padding: 10px">
            <div v-for="(trackGroupGroup, key) in trackGroupsDict" :key="key">
              <div v-show="groupBy.id === key">
                <div v-for="trackGroup in trackGroupGroup" :key="trackGroup.label" class="mb-2">
                  <b><span style="text-align: center">
                      <h2>{{ trackGroup.label }}</h2>
                    </span></b>
                  <div v-for="track in trackGroup.tracks" :key="track.id">
                    <b>{{ track.gpsTrack.name }}</b>&nbsp;
                    <span class="badge bg-dark" style="margin-right: 2px;">{{ formatDateDay(track.gpsTrack.start_time) }}</span>
                    <span :class="getDisanseBadgeClasses(track.gpsTrack)" style="margin-right: 2px;">{{ roundTrackDistance(track.gpsTrack.distance) }}</span>
                    <span v-if="track.gpsTrack.elevation_gain !== null" :class="getElevationGainBadgeClasses(track.gpsTrack)" style="margin-right: 2px;">{{ track.gpsTrack.elevation_gain }} m</span><br>
                    <template v-if="track.gpsTrack.description">{{ track.gpsTrack.description }}<br></template>
                    <br>
                    <span v-for="(photo, index) in track.gpsTrack.photos" :key="photo.id">
                      <img :key="refresh"
                        :style="{ 'margin-right': '5px', 'margin-bottom': '5px', 'cursor': 'pointer', 'object-fit': 'cover', 'object-position': 'center', 'height': calculateGalleryWidth(), 'width': calculateGalleryWidth() }"
                        :src="photo.get_image_fullhd()" @click="(event) => openTrackGallery(event, track, index)" />
                    </span>
                    <br><br><br>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="map">
          <span class="centerloading">
            <img style='height: 48px; animation: rotation 2s infinite linear;' v-if="tileLoading" :src="icons.spinnerBlack" />&nbsp;
          </span>
        </div>
      </div>
    </div>
    <div id="cogsdiv" style="display: none;">
      <div id="cogsdivinner" class="leaflet-bar leaflet-control">
        <a id="cogsdivinnera" :style="{ 'width': iconSize, 'height': iconSize, 'background-color': menuOpened ? 'yellow' : 'white' }" @click="togglePanel" class="centerall">
          <!--<b-tooltip v-if="(document.getElementById('cogsdivinner')) && (window.isDesktop)" :target="document.getElementById('cogsdivinner')">{{ menuOpened ? $t('closeMenu') : $t('openMenu') }}</<b-tooltip>-->
          <img style="height: 28px; cursor: pointer;" :src="icons.bars" />
        </a>
      </div>
    </div>
    <div id="rulerdiv" style="display: none;">
      <div id="rulerdivinner" :style="{ 'display': showIcons ? 'block' : 'none' }" class="leaflet-bar leaflet-control">
        <a id="rulerdivinnera" :style="{ 'width': iconSize, 'height': iconSize, 'background-color': $store.state.editedTrack ? 'yellow' : 'white' }" @click="rulerClick" class="centerall">
          <!--<b-tooltip v-if="(document.getElementById('rulerdivinner')) && (window.isDesktop)" :target="document.getElementById('rulerdivinner')">{{ $store.state.editedTrack ? $t('closeRuler') : $t('openRuler') }}</<b-tooltip>-->
          <img style="height: 28px; cursor: pointer;" :src="icons.rulerHorizontal" />
        </a>
      </div>
    </div>
    <div id="gallerydiv" style="display: none;">
      <div id="gallerydivinner" :style="{ 'display': showIcons ? 'block' : 'none' }" class="leaflet-bar leaflet-control">
        <a id="gallerydivinnera" :style="{ 'width': iconSize, 'height': iconSize, 'background-color': galleryOpened ? 'yellow' : 'white' }" @click="toggleGalleryPanel" class="centerall">
          <!--<b-tooltip v-if="(document.getElementById('gallerydivinner')) && (window.isDesktop)" :target="document.getElementById('gallerydivinner')">{{ galleryOpened ? $t('closeGallery') : $t('openGallery') }}</<b-tooltip>-->
          <img style="height: 28px; cursor: pointer;" :src="icons.images" />
        </a>
      </div>
    </div>
    <div id="importdiv" style="display: none;">
      <div id="importdivinner" :style="{ 'display': showIcons ? 'block' : 'none' }" class="leaflet-bar leaflet-control">
        <a id="importdivinnera" :style="{ 'width': iconSize, 'height': iconSize }" @click="openImportFileInput" class="centerall">
          <!--<b-tooltip v-if="(document.getElementById('importdivinner')) && (window.isDesktop)" :target="document.getElementById('importdivinner')">{{ $t('importGpxFile') }}</<b-tooltip>-->
          <input :key="importGpxFileCount" id="importFileInput" multiple type="file" style="display:none;" accept=".gpx" v-on:change="importGpxFileNew" />
          <img style="height: 28px; cursor: pointer;" :src="icons.upload" />
        </a>
      </div>
    </div>
    <div id="locationdiv" style="display: none;">
      <div id="locationdivinner" class="leaflet-bar leaflet-control">
        <a id="locationdivinnera" :style="{ 'width': iconSize, 'height': iconSize, 'background-color': locationActive ? 'yellow' : 'white' }" @click="toggleLocation" class="centerall">
          <!--<b-tooltip v-if="(document.getElementById('locationdivinner')) && (window.isDesktop)" :target="document.getElementById('locationdivinner')">{{ locationActive ? $t('hideLocation') : $t('showLocation') }}</<b-tooltip>-->
          <template v-if="locationActive">
            <img v-if="!currentLocation" style='height: 16px; animation: rotation 2s infinite linear;' :src="icons.spinnerBlack" />
            <img v-else style="color: green; cursor: pointer; width: 28px; height: 28px;" :src="icons.locationGreen" />
          </template>
          <img v-else style="color: green; cursor: pointer; width: 28px; height: 28px;" :src="icons.locationBlack" />
        </a>
      </div>
    </div>
    <div id="followdiv" style="display: none;">
      <div id="followdivinner" class="leaflet-bar leaflet-control">
        <a id="followdivinnera" :style="{ 'width': iconSize, 'height': iconSize, 'background-color': followActive ? 'yellow' : 'white' }" @click="toggleFollow" class="centerall">
          <!--<b-tooltip v-if="(document.getElementById('followdivinner')) && (window.isDesktop)" :target="document.getElementById('followdivinner')">{{ followActive ? $t('hideFollow') : $t('showFollow') }}</<b-tooltip>-->
          <img v-if="followActive" style="cursor: pointer; width: 28px; height: 28px;" :src="icons.followGreen" />
          <img v-else style="cursor: pointer; width: 28px; height: 28px;" :src="icons.followBlack" />
        </a>
      </div>
    </div>
    <div id="speedlegenddiv" style="display: none;">
      <div id="speedlegenddivinner">
        <div style="background-color: white; margin: 2px" v-if="$store.state.speedLegendVisible">
          <div v-for="(color, index) in $store.state.speedColors" :key="color.color"
            :style="{ 'text-align': 'center', 'color': 'white', 'width': '16px', 'height': '14px', 'margin': '1px', 'background-color': color.color }">
            <b>{{ $store.state.speedThresholds[index] }}</b>
          </div>
        </div>
      </div>
    </div>
    <div class="alertmessage">
      <div class="flexcenter">
        <div style="text-align: center;">
          <img style='height: 48px; animation: rotation 2s infinite linear;' v-if="dataRevisionLoading" :src="icons.spinnerBlack" />
          <img style='height: 48px; animation: rotation 2s infinite linear;' v-if="tracksLoading" :src="icons.spinnerBlack" />
          <img style='height: 48px; animation: rotation 2s infinite linear;' v-if="placesLoading" :src="icons.spinnerBlack" />
          <img style='height: 48px; animation: rotation 2s infinite linear;' v-if="placeTypesLoading" :src="icons.spinnerBlack" />
          <img style='height: 48px; animation: rotation 2s infinite linear;' v-if="mapsLoading" :src="icons.spinnerBlack" />
          <img style='height: 48px; animation: rotation 2s infinite linear;' v-if="regionsLoading" :src="icons.spinnerBlack" />
          <div v-if="dataRevisionLoading || tracksLoading || placesLoading || placeTypesLoading || mapsLoading || regionsLoading" style="margin: 8px;">
            <button class="btn btn-danger btn-lg" :disabled="startOfflineClicked" @click="startOffline">{{ $t('startOffline') }}</button>
          </div>
        </div>
      </div>
      <div v-for="alert in $store.state.alerts" class="alert border border-dark" v-bind:class="{ 'alert-success': isSuccessAlert(alert), 'alert-danger': isDangerAlert(alert), 'alert-warning': isWarningAlert(alert) }" v-bind:key="alert.date"
        role="alert">
        {{ alert.message }}
      </div>
    </div>
    <div id="messageDivTop" class="alertmessage" style="display: none">
      <div id="messageClassTop" class="alert border border-dark" role="alert">
        <span id="messageTop"></span>&nbsp;
        <span style="cursor: pointer" aria-hidden="true" @click="document.getElementById('messageDivTop').style.display = 'none'">&times;</span>
      </div>
    </div>
    <div v-for="language in languages" :key="language.flag" style="position: absolute; left: -10000px">
      <span :class="'fi fi-' + language.flag"></span>
    </div>
    <template v-if="(document.getElementsByClassName('leaflet-control-locate')[0]) && (window.isDesktop)">
      <!--<b-tooltip :target="document.getElementsByClassName('leaflet-control-locate')[0]">{{ $t('showMyLocation') }}</<b-tooltip>-->
    </template>
    <template v-if="(document.getElementsByClassName('leaflet-control-zoom-fullscreen')[0]) && (window.isDesktop)">
      <!--<b-tooltip ref="fullscreenTooltip" :target="document.getElementsByClassName('leaflet-control-zoom-fullscreen')[0]">{{ fullscreenOpened ? $t('exitFullscreen') : $t('enterFullscreen') }}</<b-tooltip>-->
    </template>
    <template v-if="(document.getElementsByClassName('leaflet-control-zoom-in')[0]) && (window.isDesktop)">
      <!--<b-tooltip :target="document.getElementsByClassName('leaflet-control-zoom-in')[0]">{{ $t('zoomIn') }}</<b-tooltip>-->
    </template>
    <template v-if="(document.getElementsByClassName('leaflet-control-zoom-out')[0]) && (window.isDesktop)">
      <!--<b-tooltip :target="document.getElementsByClassName('leaflet-control-zoom-out')[0]">{{ $t('zoomOut') }}</<b-tooltip>-->
    </template>
    <span>
      <AppTrackGallery v-for="track in $store.state.tracks" :track="track" :key="track.gpsTrack.id"></AppTrackGallery>
    </span>
    <template v-if="window.isDesktop">
      <TrackDetails v-for="track in $store.state.trackDetailsActivated" :track="track" :key="track.gpsTrack.id"></TrackDetails>
      <span>
        <SaveTrackModal v-for="track in $store.state.tracks" :track="track" :key="track.gpsTrack.id"></SaveTrackModal>
      </span>
      <span>
        <SaveTrackModal v-for="track in $store.state.imports" :track="track" :key="track.gpsTrack.id"></SaveTrackModal>
      </span>
      <span>
        <SaveTrackModal v-for="track in $store.state.plannedTracks" :track="track" :key="track.gpsTrack.id"></SaveTrackModal>
      </span>
      <span>
        <SaveTrackModal v-for="track in $store.state.tmpPlannedTracks" :track="track" :key="track.gpsTrack.id"></SaveTrackModal>
      </span>
      <span>
        <SaveTrackModal v-for="track in $store.state.eventTracks" :track="track" :key="track.gpsTrack.id"></SaveTrackModal>
      </span>
      <span>
        <SaveTrackModal v-for="track in $store.state.borderTracks" :track="track" :key="track.gpsTrack.id"></SaveTrackModal>
      </span>
      <span>
        <SaveTrackModal v-for="track in $store.state.otherPeopleTracks" :track="track" :key="track.gpsTrack.id"></SaveTrackModal>
      </span>
      <span>
        <SaveTrackModal v-for="track in $store.state.trailTracks" :track="track" :key="track.gpsTrack.id"></SaveTrackModal>
      </span>
      <span>
        <SavePlaceModal v-for="place in $store.state.places" :place="place" :key="place.id"></SavePlaceModal>
      </span>
    </template>
    <SavePlaceModal></SavePlaceModal>

    <!-- Modal for saving trail photos -->
    <div ref="trailPhotosSaveModal" class="modal fade" tabindex="-1" role="dialog">
      <info-modal :title="$t('saveTrailPhotos')">
        <div v-if="trailPhotosSaveModalOpened">
          <div class="container-fluid">
            <div class="row">
              <div v-for="(item, idx) in trailPhotosModalItems" :key="idx" class="col-6 px-1 py-1">
                <div class="p-1" style="text-align:center;">
                  <img :src="item.url" style="width:100%; height:auto; border:1px solid #ccc; display:block;" />
                  <div class="d-flex align-items-center justify-content-start mt-2">
                    <b-form-checkbox v-model="item.selected" class="me-2"></b-form-checkbox>
                    <VueSelect style="max-width: 48%; display:inline-block;" v-model="item.type" :options="$store.state.placeTypes" label="name" :clearable="false" :searchable="false"></VueSelect>
                    <input class="form-control form-control-sm" v-model="item.name" style="width:40%; margin-left: 10px;" />
                  </div>
                </div>
              </div>
            </div>
            <div v-if="trailPhotosSaveInProgress" class="row mt-2">
              <div class="col-12">
                <b-progress :max="100" show-progress animated>
                  <b-progress-bar :value="trailPhotosSaveProgress" show-progress animated>
                    <strong>{{ trailPhotosSaveProgress.toFixed(0) }}%</strong>
                  </b-progress-bar>
                </b-progress>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-success" :disabled="trailPhotosSaveInProgress || !hasSelectedTrailPhotos()" @click="saveTrailPhotos"><strong>{{ $t('save') }}</strong></button>
          <button type="button" class="btn btn-primary" @click="closeSaveTrailPhotosModal"><strong>{{ $t('close') }}</strong></button>
        </div>
      </info-modal>
    </div>

  </div>
</template>

<script lang="ts">
import L from 'leaflet';
import axios, { type AxiosInstance } from 'axios';
import $ from 'jquery';
import BaseComponent from '@/components/Base.vue';
import { AlertStatus, TrackStatus, TrackType, type LayersDictionary, DataOrigin, DownloadStatus } from '@/ts/types';
import Track from '@/ts/Track';
import Region from '@/ts/Region';
import Place from '@/ts/Place';
import GpsTrack from '@/ts/GpsTrack';
import i18n from '@/ts/i18n';
import YearTrackGrouper from '@/ts/trackgroupers/year';
import TypeTrackGrouper from '@/ts/trackgroupers/type';
import RegionTrackGrouper from '@/ts/trackgroupers/region';
import TrackGroup from '@/ts/TrackGroup';
import listTranslator from '@/ts/list_translator';
import PlaceType from '@/ts/PlaceType';
import Photo from '../ts/Photo';
import { EventBus } from '@/ts/EventBus';
import Area from '@/ts/Area';
import VideoLink from '@/ts/VideoLink';
import moment from 'moment';
import { TileLayerOffline, createSaveTilesControl, type ControlSaveTiles } from '@/ts/leafletoffline';
import * as icons from '@/ts/icons';
import ExifReader from 'exifreader';
import { formatTimeSeconds } from '@/ts/utils';
// @ts-ignore
import GPX from 'gpx-parser-builder';
import { distanceBetweenPoints } from '@/ts/utils/coords';
import * as xml2js from 'xml2js';
import * as opfs_utils from '@/ts/utils/opfs';
import FullScreen from 'leaflet.fullscreen';
import { defineComponent } from "vue";
import { gridDebugLayer } from '@/ts/GridDebugLayer';
import { NMTLayer } from '@/ts/NMTLayer';
import { NMTContourLayer } from '@/ts/NMTContourLayer';
import { stringify } from 'querystring';
import { anchorY } from 'highcharts';
import { log as debugLog, error as debugError } from '@/ts/debug';

interface FileReaderEventTarget extends EventTarget {
  result: string;
}

export default defineComponent({
  extends: BaseComponent,
  data() {
    const axiosInstanceForLocalhost: AxiosInstance = null;
    const followInterval: NodeJS.Timeout = null;
    const locationWatchID: number = undefined;
    const currentLocation: [number, number] = null;
    const overlays: LayersDictionary = {};
    const layers: LayersDictionary = {};
    const dataRevision: Object = null;
    const dataRevisionAbortController: AbortController = null;
    const tracksAbortController: AbortController = null;
    const placesAbortController: AbortController = null;
    const placeTypesAbortController: AbortController = null;
    const regionsAbortController: AbortController = null;
    const mapsAbortController: AbortController = null;
    const node: any = null;
    const followMarker: L.CircleMarker = null;
    const searchText: string = '';
    const cache: boolean = false;
    const lastMouseDownPoint: any = null;
    const lastMouseDownTime: number = null;
    const locationMarker: L.CircleMarker = null;
    const noSleep: any = null;
    const baseMaps: LayersDictionary = {};
    const layerName: string = null;
    const openCycleMapOfflineLayer: L.Layer = null;
    const password: string = '';
    const login: string = '';
    const language: { flag: string, language: string, label: string } | null = null;
    const importGroup: TrackGroup = new TrackGroup();
    const trackGroupsDict: { [key: string]: TrackGroup[] } = {};
    const imagesInRow: number = null;
    const tileLoading: boolean = true;
    const dataRevisionLoading: boolean = false;
    const tracksLoading: boolean = false;
    const placesLoading: boolean = false;
    const placeTypesLoading: boolean = false;
    const regionsLoading: boolean = false;
    const mapsLoading: boolean = false;
    const groups = [{ id: 'year', translate: 'year', label: '', grouper: new YearTrackGrouper() }, { id: 'type', translate: 'type', label: '', grouper: new TypeTrackGrouper() }, { id: 'region', translate: 'region', label: '', grouper: new RegionTrackGrouper() }];

    return {
      dataRevisionLoading,
      tracksLoading,
      placesLoading,
      placeTypesLoading,
      regionsLoading,
      mapsLoading,
      tileLoading,
      startOfflineClicked: false,
      menuOpened: false,
      galleryOpened: false,
      document: document,
      fullscreenOpened: false,
      imagesInRow,
      refresh: 1,
      importGpxFileCount: 0,
      speedScaleChoose: "1",
      mainGalleryOpened: false,
      groups,
      groupBy: groups[0],
      trackGroupsDict,
      importGroup,
      languages: [{ flag: 'us', language: 'en', label: 'English' }, { flag: 'pl', language: 'pl', label: 'Polski' }],
      language,
      login,
      password,
      //@ts-ignore
      TrackType: TrackType,
      openCycleMapOfflineLayer,
      progress: 0,
      totalToSave: 0,
      layerName,
      baseMaps,
      noSleepActive: false,
      noSleep,
      locationActive: false,
      locationMarker,
      lastMouseDownTime,
      lastMouseDownPoint,
      cache,
      searchText,
      tlo: TileLayerOffline,
      nmtLayer: NMTLayer,
      nmtContourLayer: NMTContourLayer,
      useHTML5location: false,
      rotateDuringNavigation: false,
      largeButtonsDuringLocation: false,
      showAllButtonsDuringLocation: false,
      lockPortrait: false,
      icons: icons,
      trailPhotosAdded: false,
      trailPhotosModalItems: [] as any,
      trailPhotosSaveModalOpened: false,
      trailPhotosSaveInProgress: false,
      trailPhotosSaveProgress: 0,
      trailPhotosSaveTotal: 0,
      followActive: false,
      followMarker,

      iconSize: '48px',
      showIcons: true,
      loginInProgress: false,
      node,
      dataRevision,
      dataRevisionAbortController,
      tracksAbortController,
      placesAbortController,
      placeTypesAbortController,
      regionsAbortController,
      mapsAbortController,
      
      layers,
      overlays,
      currentLocation,
      followLocation: false,
      locationInterval: null as NodeJS.Timeout,
      lastTime: 0,
      locationWatchID,
      followInterval,
      axiosInstanceForLocalhost,
      fullScreenControl: null as FullScreen,

      palettes: [0, 1],
      paletteChoose: 0,
      uniformTrackColor: '#FF0000' as any,
      uniformTrackOriginalColors: {} as Record<number, string>,
      uniformTrackColorApplied: false,
      paletteMin: 20,
      paletteMax: 105,
      binaryLayerAlpha: 255,
      waitingForRedraw: false,

      rotateAngleThreshold: {'value': 5, 'label': '5°'},
      rotateAngleThresholds: [] as any,

      rotateMeterThreshold: {'value': 1, 'label': '1m'},
      rotateMeterThresholds: [] as any,
      lastBearing: null as number | null,
      lastRotatePoint: null as [number, number] | null,
      lastRotateIndex: null as number | null,
    };
  },
  async mounted() {
    this.rotateAngleThresholds = []
    for (let i = 0; i <= 45; i++) {
      this.rotateAngleThresholds.push({'value': i, 'label': String(i) + '°'})
    }
    for (let i = 0; i <= 11; i++) {
      this.rotateMeterThresholds.push({'value': i / 2, 'label': String(i/2) + 'm'});
    }
    this.axiosInstanceForLocalhost = axios.create();
    this.axiosInstanceForLocalhost.defaults.headers.common = {};
    this.loadKVsettings();
    window.binaryLayerAlpha = this.binaryLayerAlpha;
    this.setLanguage();
    this.setStoreToken();
    await this.downloadDataRevision();
    this.createMap([52.743682, 16.273668], 11);
    await this.downloadAndAddLayers();
    this.addZoomControl();
    this.createSpeedLegendControl();
    this.addScaleControl();
    this.addFullScreenControl();
    this.addCogsButton();
    this.addGalleryButton();
    this.addRulerButton();
    this.addImportButton();
    this.addLocationButton();
    this.addFollowButton();
    this.downloadTracks();
    this.downloadRegions();
    this.downloadPlaceTypes();
    this.downloadPlaces();
    this.activateNoSleep();
    this.changeButtonSizeDuringLocation();
    this.addMapZoomNumber(null);
    new ResizeObserver(() => {
      this.refresh += 1;
    }).observe(document.getElementById('main_gallery_div'));
  },
  created() {
    // non-reactive storage for trail photo markers
    // store as plain property on the component instance
    // so Vue won't make markers reactive
    // @ts-ignore
    this._trailPhotoMarkers = [];
    // @ts-ignore
    this._currentLocationTrack = [];
    // @ts-ignore
    this._currentLocationTrackOnMap = null;
  },
  updated() {
    for (const alert of this.$store.state.alerts) {
      if (!alert.startTimeout) {
        alert.startTimeout = true;
        window.setTimeout(() => {
          this.$store.commit('removeAlert', alert.id);
        }, alert.timeout);
      }
    }
  },
  methods: {
    applyUniformTrackColor() {
      const selectedColor = this.getUniformTrackColor();
      if (!selectedColor) {
        return;
      }
      if (!this.uniformTrackColorApplied) {
        this.uniformTrackOriginalColors = {};
        for (const track of this.$store.state.tracks) {
          this.uniformTrackOriginalColors[track.id] = track.gpsTrack.color;
        }
      }
      for (const track of this.$store.state.tracks) {
        track.gpsTrack.color = selectedColor;
      }
      this.uniformTrackColorApplied = true;
      this.updateUniformTrackStyle();
    },
    getUniformTrackColor(): string {
      if (typeof this.uniformTrackColor === 'string') {
        return this.uniformTrackColor;
      }
      if (this.uniformTrackColor?.rgba) {
        const rgba = this.uniformTrackColor.rgba;
        return `rgba(${rgba.r}, ${rgba.g}, ${rgba.b}, ${rgba.a})`;
      }
      return this.uniformTrackColor?.hex;
    },
    updateUniformTrackStyle() {
      if (!this.uniformTrackColorApplied) {
        return;
      }
      const selectedColor = this.getUniformTrackColor();
      for (const track of this.$store.state.tracks) {
        const leafletTrack = window.tracks[track.id];
        if (leafletTrack) {
          for (const mapTrack of leafletTrack.mapTracks) {
            mapTrack.setStyle({ color: selectedColor });
          }
        }
      }
    },
    restoreTrackColors() {
      for (const track of this.$store.state.tracks) {
        const originalColor = this.uniformTrackOriginalColors[track.id];
        if (originalColor) {
          track.gpsTrack.color = originalColor;
          const leafletTrack = window.tracks[track.id];
          if (leafletTrack) {
            for (const mapTrack of leafletTrack.mapTracks) {
              mapTrack.setStyle({ color: originalColor });
            }
          }
        }
      }
      this.uniformTrackColorApplied = false;
      this.uniformTrackOriginalColors = {};
    },
    activateNoSleep() {
      setTimeout(() => {
        EventBus.$emit('activateNoSleep');
      }, 15000);
    },
    toggleHTML5locationIfPossible() {
      if (! this.locationActive) {
        this.useHTML5location = !this.useHTML5location
      }
    },
    lockOrUnlockScreen() {
      if ((this.locationActive) && (this.lockPortrait)) {
        // @ts-ignore
        screen.orientation.lock("portrait").then(() => {
          this.createAlert(AlertStatus.success, this.$t('lockCreated').toString(), 2000);
        }).catch(() => {
          this.createAlert(AlertStatus.danger, this.$t('lockError').toString(), 2000);
        });
      } else {
        try {
          screen.orientation.unlock();
        } catch {
        }
      }
    },
    calculateGalleryWidth() {
      const div = document.getElementById('mainGalleryPhotos');
      if (div) {
        if (!this.imagesInRow) {
          this.calculateImagesInRowAtStart();
        }
        const width = div.getBoundingClientRect().width - 20 - 5 * this.imagesInRow;
        return Math.floor(width / this.imagesInRow) + 'px';
      } else {
        this.refresh = this.refresh + 1;
        return '300px';
      }
    },
    async startThumbsCacheForPlaces() {
      await opfs_utils.openDirectory();
      if (this.$store.state.places) {
        for (const place of this.$store.state.places) {
          for (const photo of place.photos) {
            await opfs_utils.checkOrCachePhoto(photo.image_thumb);
            await opfs_utils.checkOrCachePhoto(photo.image_fullhd);
          }
        }
      }
    },
    async startThumbsCacheForTracks() {
      if (this.$store.state.tracks) {
        for (const track of this.$store.state.tracks) {
          for (const photo of track.gpsTrack.photos) {
            await opfs_utils.checkOrCachePhoto(photo.image_thumb);
            await opfs_utils.checkOrCachePhoto(photo.image_fullhd);
          }
        }
      }
    },
    changeButtonSizeDuringLocation() {
      if (this.locationActive) {
        if (this.largeButtonsDuringLocation) {
          this.iconSize = '64px';
          $(".leaflet-control-layers-toggle").attr('style', 'width: 64px !important; height: 64px !important');
          $(".leaflet-control-zoom-in").attr('style', 'width: 64px !important; height: 64px !important');
          $(".leaflet-control-zoom-out").attr('style', 'width: 64px !important; height: 64px !important');
          $(".leaflet-control-zoom-fullscreen").attr('style', 'width: 64px !important; height: 64px !important');
          if (this.showAllButtonsDuringLocation) {
            this.showIcons = true;
          } else {
            this.showIcons = false;
          }
        } else {
          this.iconSize = '48px';
          $(".leaflet-control-layers-toggle").attr('style', 'width: 48px !important; height: 48px !important');
          $(".leaflet-control-zoom-in").attr('style', 'width: 48px !important; height: 48px !important');
          $(".leaflet-control-zoom-out").attr('style', 'width: 48px !important; height: 48px !important');
          $(".leaflet-control-zoom-fullscreen").attr('style', 'width: 48px !important; height: 48px !important');
          if (this.showAllButtonsDuringLocation) {
            this.showIcons = true;
          } else {
            this.showIcons = false;
          }
        }
      } else {
        $(".leaflet-control-layers-toggle").attr('style', 'width: 48px !important; height: 48px !important');
        $(".leaflet-control-zoom-in").attr('style', 'width: 48px !important; height: 48px !important');
        $(".leaflet-control-zoom-out").attr('style', 'width: 48px !important; height: 48px !important');
        $(".leaflet-control-zoom-fullscreen").attr('style', 'width: 48px !important; height: 48px !important');
        this.iconSize = '48px';
        this.showIcons = true;
      }
    },
    getRandomInt(max: number) {
      return Math.floor(Math.random() * max);
    },
    logInToApi() {
      this.loginInProgress = true;
      axios.post(window.apiHost + 'api/loginuser/', { username: this.login, password: this.password }).then((response) => {
        this.createAlert(AlertStatus.success, this.$t('logInSuccess').toString(), 2000);
        this.$store.commit('setToken', response.data.auth_token);
        this.$store.commit('setUser', response.data.username);
        this.refreshPhotos();
      }).catch((response) => {
        this.createAlert(AlertStatus.danger, this.$t('logInError').toString(), 2000);
      },
      ).finally(() => {
        this.login = '';
        this.password = '';
        this.loginInProgress = false;
      });
    },
    logOutFromApi() {
      this.createAlert(AlertStatus.success, this.$t('logOutSuccess').toString(), 2000);
      this.$store.commit('setToken', null);
      this.$store.commit('setUser', null);
      this.refreshPhotos();
    },
    setStoreToken() {
      const maplasToken = localStorage.getItem('maplasToken');
      const maplasUser = localStorage.getItem('maplasUser');
      if (maplasUser) {
        this.$store.commit('setUser', maplasUser);
        this.createAlert(AlertStatus.success, this.$t('welcome').toString() + ': ' + maplasUser, 2000);
      }
      if (maplasToken) {
        this.$store.commit('setToken', maplasToken);
        this.refreshLoginInfo();
      }
    },
    refreshLoginInfo() {
      axios.get(window.apiHost + 'api/loggeduserinfo/').then((response) => {
      }).catch((error) => {
        if ((error.response) && (error.response.status == 401)) {
          this.$store.commit('setToken', null);
          this.$store.commit('setUser', null);
          this.createAlert(AlertStatus.danger, this.$t('logInSessionExpired').toString(), 2000);
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        }
      });
    },
    loadKVsettings() {
      this.largeButtonsDuringLocation = (localStorage.getItem('largeButtonsDuringLocation') == 'true');
      this.showAllButtonsDuringLocation = (localStorage.getItem('showAllButtonsDuringLocation') == 'true');
      this.useHTML5location = (localStorage.getItem('useHTML5location') == 'true');
      this.rotateDuringNavigation = (localStorage.getItem('rotateDuringNavigation') == 'true');
      this.lockPortrait = (localStorage.getItem('lockPortrait') == 'true');
      debugLog('KV settings loaded');
    },
    createAbortConfig() {
      let abortController: AbortController = null;
      try {
        abortController = (typeof AbortController !== 'undefined') ? new AbortController() : null;
      } catch (e) {
        abortController = null;
      }
      const config: any = {};
      if (abortController) {
        config.signal = abortController.signal;
        return [config, abortController];
      }
      return [null, null];
    },
    abortRequest(controller: AbortController) {
      if (controller) {
        controller.abort();
      }
    },
    async downloadDataRevision() {
      const endPoint = window.apiHost + 'api/datarevision/';
      let config;
      [config, this.dataRevisionAbortController] = this.createAbortConfig();
      this.dataRevisionLoading = true;
      try {
        const response = await axios.get(endPoint, config);
        this.$store.state.dataRevision = response.data.datarevision;
      } catch (err: any) {
        this.createAlert(AlertStatus.danger, this.$t('dataRevisionError').toString(), 2000);
      } finally {
        this.dataRevisionLoading = false;
      }
    },
    startOffline() {
      this.startOfflineClicked = true;
      this.abortRequest(this.dataRevisionAbortController);
      this.abortRequest(this.tracksAbortController);
      this.abortRequest(this.placeTypesAbortController);
      this.abortRequest(this.placesAbortController);
      this.abortRequest(this.regionsAbortController);
      this.abortRequest(this.mapsAbortController);
    },
    calculateImagesInRowAtStart() {
      const width = document.getElementById('mainGalleryPhotos').getBoundingClientRect().width;
      this.imagesInRow = Math.max(Math.floor(width / 300), 1);
    },
    addZoomControl() {
      L.control.zoom({
        position: 'topright'
      }).addTo(window.mainmap);
      window.mainmap.on('zoomend', () => {
        this.$store.commit('setZoomLevel', window.mainmap.getZoom())
      })
    },
    rulerClick(e: Event) {
      if (this.$store.state.editedTrack) {
        this.$store.commit('setEditedTrack', null);
      } else {
        EventBus.$emit('newPlannedTrack');
      }
      e.stopPropagation();
    },
    showAllTracks() {
      for (const track of this.$store.state.tracks) {
        track.checked = true;
      }
    },
    hideAllTracks() {
      for (const track of this.$store.state.tracks) {
        track.checked = false;
      }
    },
    expandAllGroups() {
      EventBus.$emit('expandAllGroups');
    },
    hideAllGroups() {
      EventBus.$emit('hideAllGroups');
    },
    setLanguage() {
      if (typeof this.$route.query.lang === 'string') {
        for (const lang of this.languages) {
          if (this.$route.query.lang === lang.language) {
            this.language = lang;
          }
        }
        if (!this.language) {
          this.language = this.languages[1];
        }
      } else {
        this.language = this.languages[1];
      }
      this.translateAndAddArrayToTranslator(this.groups);
      this.onLanguageChanged();
    },
    mapClicked(e: L.LeafletMouseEvent) {
      if (this.$store.state.editedTrack) {
        this.$store.state.editedTrack.addPoint(e.latlng.lat, e.latlng.lng, window.mainmap);
      } else if (this.$store.state.editedArea) {
        this.$store.state.editedArea.addPoint(e.latlng)
      } else {
        this.followLocation = true;
        if (this.currentLocation) {
          window.mainmap.panTo(this.currentLocation);
        }
      }
    },
    addMapZoomNumber(e: L.LeafletEvent) {
      if (!document.getElementById('currentZoomId')) {
        this.node = document.createElement("span");
        this.node.id = 'currentZoomId';
        this.node.style.backgroundColor = 'rgba(255, 255, 255, 0.95)';
        this.node.style.border = '2px solid #777';
        this.node.style.paddingLeft = '4px';
        this.node.style.paddingRight = '4px';
        this.node.style.borderTop = '0px';
        const scale = document.getElementsByClassName('leaflet-control-scale leaflet-control');
        if (scale.length) {
          scale[0].appendChild(this.node);
        }
      }
      this.node.innerHTML = Math.round(window.mainmap.getZoom() * 100) / 100;
    },
    openNewPlaceModal(event: L.ContextMenuItemClickEvent, map: L.Map) {
      if (this.$store.state.user) {
        EventBus.$emit('NewPlaceRequested', false, event.latlng);
      } else {
        this.createAlert(AlertStatus.danger, this.$t('notLoggedToAddPlace') as string, 2000);
      }
    },
    setLayer(layerName: string) {
      for(const layer in this.$store.state.baseMaps) {
        this.$store.state.baseMaps[layer].removeFrom(window.mainmap);
      }
      for(const layer in this.$store.state.baseMaps) {
        debugLog(layer);
        if (layer == layerName) {
          this.$store.state.baseMaps[layer].addTo(window.mainmap)
        }
      }
    },
    addOrRemoveOverlayLayer(layerNames: string[]) {
      let removed = false;
      for(const layer in window.overlayLayers) {
        if(window.mainmap.hasLayer(window.overlayLayers[layer]) && (layerNames.includes(layer))) {
          window.overlayLayers[layer].removeFrom(window.mainmap);
          removed = true;
        }
      }
      if (removed == false) {
        for(const layer in window.overlayLayers) {
          if (layerNames.includes(layer)) {
            window.overlayLayers[layer].addTo(window.mainmap);
          }
        }
      }
    },
    createMap(center: [number, number], zoom: number) {
      let map: L.Map = null;
      if (window.isDesktop) {
        map = L.map('map', {
          zoomAnimation: false,
          zoomControl: false,
          doubleClickZoom: false,
          renderer: L.canvas({ padding: 0.1 }),
          rotate: true,
          rotateControl: false,
          touchRotate: false,
          contextmenu: true,
          contextmenuItems: [{
            text: this.$t('addPlace'),
            callback: this.openNewPlaceModal
          }, {
            text: this.$t('copyCoordinates'),
            callback: (e: L.ContextMenuItemClickEvent, map: L.Map) => {
              //@ts-ignore
              //navigator.permissions.query({ name: "write-on-clipboard" }).then((result) => {
              //  if (result.state == "granted" || result.state == "prompt") {
              //    
              //  }
              //});
              const coords = e.latlng.lat.toFixed(6) + ', ' + e.latlng.lng.toFixed(6);
              navigator.clipboard.writeText(coords).then(() => {
                this.createAlert(AlertStatus.success, this.$t('copied', [coords]), 2000)
              }, () => {
                this.createAlert(AlertStatus.danger, this.$t('copyError'), 2000)
              });
            }
          }, {
            text: this.$t('measureHeight'),
            callback: (e: L.ContextMenuItemClickEvent, map: L.Map) => {
              const url = window.apiHost + 'api/measureheight/?lat=' + e.latlng.lat + '&lon=' + e.latlng.lng;
              axios.get(url).then((response) => {
                this.createAlert(AlertStatus.success, response.data.height / 100 + ' m', 2000)
              }).catch(() => {
                this.createAlert(AlertStatus.danger, this.$t('measureHeightError'), 2000)
              });
            }
          }],
          //@ts-ignore
          contextmenuWidth: 140,
        });
      } else {
        map = L.map('map', {
          zoomAnimation: false,
          zoomControl: false,
          doubleClickZoom: false,
          zoomDelta: 1,
          zoomSnap: 0.1,
          rotate: true,
          rotateControl: false,
          touchRotate: false,
          contextmenu: false,
          contextmenuItems: [],
          renderer: L.canvas({ padding: 0.1 }),
        });
      }
      map.setView(center, zoom);
      window.mainmap = map;
      // @ts-ignore MarkersCanvas is registered on Leaflet by the plugin import.
      window.markersCanvas = new L.MarkersCanvas({ pane: 'markerPane' });
      window.markersCanvas.addTo(map);
      this.$store.commit('setZoomLevel', zoom);
      map.on('click', this.mapClicked);
      map.on('move', this.addMapZoomNumber);
      map.on('moveend', this.addMapZoomNumber);
      map.on('dblclick', (event) => {
        if (!(this.$store.state.editedTrack || this.$store.state.editedArea)) {
          map.setZoomAround(event.containerPoint, map.getZoom() + 1);
        }
      });
      map.on('dragstart', () => { this.followLocation = false });
      if (window.isPwa) {
        map.on('contextmenu', (e: L.LeafletMouseEvent) => {
          map.setZoomAround(e.latlng, map.getZoom() - 1);
        })
      }
      map.on('baselayerchange', (event: L.LayersControlEvent) => {
        //@ts-ignore
        window.gridDebugLayer.options.maxZoom = event.layer.options.maxZoom;
        //@ts-ignore
        window.gridDebugLayer.options.maxNativeZoom = event.layer.options.maxNativeZoom;
        window.activeLayer = event.layer as L.TileLayer;
      })
      map.on('keydown', (event) => {
        if (event.originalEvent.key == '1') {
          this.setLayer('OpenStreetMap')
        }
        if (event.originalEvent.key == '2') {
          this.setLayer('Esri Imaginery')
        }
        if (event.originalEvent.key == '3') {
          this.setLayer('Geoportal Orto')
        }
        if (event.originalEvent.key == '4') {
          this.setLayer('Google Satelitte')
        }
        if (event.originalEvent.key == '8') {
          this.addOrRemoveOverlayLayer(['NMT'])
        }
        if (event.originalEvent.key == '9') {
          this.addOrRemoveOverlayLayer(['NMT Poziomice'])
        }
        if (event.originalEvent.key == '0') {
          this.addOrRemoveOverlayLayer(['Strava Heatmap blue', 'Strava Heatmap blue 03.2026'])
        }
        if (event.originalEvent.key.toLowerCase() == 'z') {
          if (this.$store.getters.selectedTracks.length == 0) {
            this.showAllTracks();
          } else {
            this.hideAllTracks();
          }
        }
        if (event.originalEvent.key.toLowerCase() == 'x') {
          EventBus.$emit('togglePlaceTypeGroup_places');
        }
        if (event.originalEvent.key.toLowerCase() == 'c') {
          EventBus.$emit('togglePlaceTypeGroup_roads');
        }
        if (event.originalEvent.key.toLowerCase() == 'n') {
          this.togglePanel(null);
        }
        if (event.originalEvent.key.toLowerCase() == 'm') {
          this.toggleGalleryPanel(null);
        }
        if (event.originalEvent.key.toLowerCase() == 'u') {
          EventBus.$emit('hideVisitedTiles');
        }
        if (event.originalEvent.key.toLowerCase() == 'i') {
          EventBus.$emit('showOSMVisitedTiles');
        }
        if (event.originalEvent.key.toLowerCase() == 'o') {
          EventBus.$emit('showEPSG3857VisitedTiles');
        }
        if (event.originalEvent.key.toLowerCase() == 'p') {
          EventBus.$emit('toggleVisitedTilesAllLines');
        }
        if (event.originalEvent.key.toLowerCase() == 'a') {
          EventBus.$emit('toggleCzasWLas');
        }
        if (event.originalEvent.key.toLowerCase() == 's') {
          EventBus.$emit('toggleOSMPoints');
        }
        if (event.originalEvent.key.toLowerCase() == 'd') {
          EventBus.$emit('toggleKomootTrailView');
        }
        if (event.originalEvent.key.toLowerCase() == 'f') {
          EventBus.$emit('toggleKomootToursPhotos');
        }
        if (event.originalEvent.key.toLowerCase() == 'g') {
          EventBus.$emit('toggleKomootPoi');
        }
        if (event.originalEvent.key.toLowerCase() == 'h') {
          EventBus.$emit('toggleOSMCycleways');
        }
        if (event.originalEvent.key.toLowerCase() == 'j') {
          EventBus.$emit('toggleKomootTours');
        }
        if (event.originalEvent.key.toLowerCase() == 'k') {
          EventBus.$emit('toggleStravaSegments');
        }
        if (event.originalEvent.key.toLowerCase() == 'l') {
          EventBus.$emit('toggleDpoz');
        }
        if (event.originalEvent.key.toLowerCase() == 'b') {
          EventBus.$emit('toggleBdl');
        }
      });
    },
    processMapLayers(result: { dict_key: string, javascript_code: string, display_name: string, type: string }[]) {
      this.layers = {};
      this.overlays = {};
      let firstLayer = '';
      this.baseMaps = {}
      let firstLayerMaxZoom = null;
      let firstLayerMaxNativeZoom = null;
      if (result.length > 0) {
        for (const layer of result) {
          const dict = layer.type == 'base' ? this.layers : this.overlays;
          dict[layer.display_name] = eval(layer.javascript_code);
          if (layer.type == 'base') {
            dict[layer.display_name]['options']['errorTileUrl'] = icons.tileDownloadError;
          }
          if (layer.type == 'overlay') {
            dict[layer.display_name]['options']['errorTileUrl'] = icons.tileDownloadErrorTransparent;
          }
          dict[layer.display_name]['options']['attribution'] = '';
          dict[layer.display_name]['options']['layerName'] = layer.display_name;
          if (layer.type == 'base') {
            this.baseMaps[layer.display_name] = this.layers[layer.display_name];
            if (!firstLayer) {
              firstLayer = layer.display_name;
              firstLayerMaxZoom = dict[layer.display_name]['options']['maxZoom'];
              firstLayerMaxNativeZoom = dict[layer.display_name]['options']['maxNativeZoom'];
            }
          }
        }
      } else {
        this.layers['OpenStreetMap'] = new L.TileLayer('https://tile.osm.org/{z}/{x}/{y}.png', {
          maxZoom: 19,
          attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
          layerName: 'OpenStreetMap',
        });
        this.baseMaps['OpenStreetMap'] = this.layers['OpenStreetMap'];
        firstLayer = 'OpenStreetMap';
        firstLayerMaxZoom = 19;
        firstLayerMaxNativeZoom = 19;
      }

      window.gridDebugLayer = gridDebugLayer({ maxZoom: firstLayerMaxZoom, maxNativeZoom: firstLayerMaxNativeZoom });

      this.$store.state.baseMaps = this.baseMaps;
      window.overlayLayers = this.overlays;
      // Notify components that overlay layers are registered
      EventBus.$emit('overlayLayersReady', this.overlays);

      for (const layer in this.baseMaps) {
        if (this.baseMaps.hasOwnProperty(layer)) {
          this.baseMaps[layer].on('loading', (event) => {
            this.tileLoading = true;
          });
          this.baseMaps[layer].on('load', (event) => {
            this.tileLoading = false;
          });
        }
      }

      let availableLayers: string = '';
      for (const layer in this.layers) {
        if (this.layers.hasOwnProperty(layer)) {
          availableLayers = availableLayers + layer + ', ';
        }
      }
      debugLog(`Available layers: ${availableLayers}`);

      const maplayer: string = (typeof this.$route.query.maplayer === 'string') ? this.$route.query.maplayer : '';
      window.layerControl = L.control.layers(this.baseMaps, this.overlays).addTo(window.mainmap);
      if (this.layers.hasOwnProperty(maplayer)) {
        this.layers[maplayer].addTo(window.mainmap!);
      } else {
        if (maplayer.length > 0) {
          this.createAlert(AlertStatus.danger, `Param maplayer ${maplayer} provided, but layer not found in avaliable layers`, 2000);
        }
        this.layers[firstLayer].addTo(window.mainmap!);
      }
    },
    async downloadAndAddLayers() {
      const endPoint = window.apiHost + 'api/maplayers/';
      try {
        let config;
        [config, this.mapsAbortController] = this.createAbortConfig();
        this.mapsLoading = true;
        const response: any = await this.downloadUrlWithCache(endPoint, 'main', 'maplayers.txt', config, !this.startOfflineClicked);
        if (response[0] == DownloadStatus.cache_fresh) {
          this.createAlert(AlertStatus.success, this.$t('layersLoaded', [response[1].results.length]).toString(), 2000);
        }
        if (response[0] == DownloadStatus.api_fresh) {
          this.createAlert(AlertStatus.success, this.$t('layersDownloaded', [response[1].results.length]).toString(), 2000);
        }
        if (response[0] == DownloadStatus.cache_last) {
          this.createAlert(AlertStatus.warning, this.$t('layersLoaded', [response[1].results.length]).toString(), 2000);
        }
        this.processMapLayers(response[1].results);
      } catch (e) {
        this.createAlert(AlertStatus.danger, this.$t('layersError').toString(), 2000);
      } finally {
        this.mapsLoading = false;
      }
    },
    addCogsButton() {
      const CogsControl = L.Control.extend({
        options: {
          position: 'topright',
        },
        onAdd: (map: L.Map) => {
          return document.getElementById('cogsdivinner');
        },
      });
      window.mainmap!.addControl(new CogsControl());
    },
    addGalleryButton() {
      const GalleryControl = L.Control.extend({
        options: {
          position: 'topright',
        },
        onAdd: (map: L.Map) => {
          return document.getElementById('gallerydivinner');
        },
      });
      window.mainmap!.addControl(new GalleryControl());
    },
    addRulerButton() {
      const RulerControl = L.Control.extend({
        options: {
          position: 'topright',
        },
        onAdd: (map: L.Map) => {
          return document.getElementById('rulerdivinner');
        },
      });
      window.mainmap!.addControl(new RulerControl());
    },
    createSpeedLegendControl() {
      const LegendControl = L.Control.extend({
        options: {
          position: 'bottomleft',
        },
        onAdd: (map: L.Map) => {
          return document.getElementById('speedlegenddivinner');
        },
      });
      window.mainmap.addControl(new LegendControl());
    },
    addImportButton() {
      const ImportControl = L.Control.extend({
        options: {
          position: 'topright',
        },
        onAdd: (map: L.Map) => {
          return document.getElementById('importdivinner');
        },
      });
      if (window.isDesktop) {
        window.mainmap.addControl(new ImportControl());
      }
      this.importGroup.translate = 'imports';
    },
    formatDateMs(date: any) {
      return moment(date).format('DD.MM.YYYY H:mm:ss.SSS');
    },
    setBearing() {
      if (!this.rotateDuringNavigation) {
        return;
      }

      const track = (this as any)._currentLocationTrack as [number, number][];
      if (!track || track.length === 0) return;

      const lastIdx = track.length - 1;
      const last = track[lastIdx];

      const rotateAngle = Number(this.rotateAngleThreshold?.value || 0);
      const rotateMeter = Number(this.rotateMeterThreshold?.value || 0);

      // Helper: minimal angular difference (0..180)
      const angularDiff = (a: number, b: number) => Math.abs(((a - b + 540) % 360) - 180);

      // Determine base point to compute bearing from
      let basePoint: any = null;
      // If we have a previously applied rotate point, use it
      if (this.lastRotatePoint && Array.isArray(this.lastRotatePoint) && this.lastRotatePoint.length >= 2) {
        const d = L.latLng(this.lastRotatePoint[0], this.lastRotatePoint[1]).distanceTo(L.latLng(last[0], last[1]));
        // require distance since last rotation to exceed threshold before considering angle
        if (d < rotateMeter) {
          return; // not far enough yet
        }
        basePoint = this.lastRotatePoint;
      } else {
        // No lastRotatePoint: find previous track point at least rotateMeter away from last
        for (let i = lastIdx - 1; i >= 0; i--) {
          const candidate = track[i];
          if (candidate && candidate.length >= 2) {
            const dist = L.latLng(candidate[0], candidate[1]).distanceTo(L.latLng(last[0], last[1]));
            if (dist >= rotateMeter) {
              basePoint = candidate;
              break;
            }
          }
        }
        // if still no basePoint, nothing to do
        if (!basePoint) return;
      }

      // compute bearing from basePoint -> last
      let bearing = 0;
      try {
        const lat1 = basePoint[0] * Math.PI / 180;
        const lon1 = basePoint[1] * Math.PI / 180;
        const lat2 = last[0] * Math.PI / 180;
        const lon2 = last[1] * Math.PI / 180;
        const dLon = lon2 - lon1;
        const y = Math.sin(dLon) * Math.cos(lat2);
        const x = Math.cos(lat1) * Math.sin(lat2) - Math.sin(lat1) * Math.cos(lat2) * Math.cos(dLon);
        bearing = (Math.atan2(y, x) * 180 / Math.PI + 360) % 360;
      } catch (e) {
        return;
      }

      // Angle threshold check vs lastBearing
      let anglePassed = true;
      if (this.lastBearing !== null && typeof this.lastBearing !== 'undefined') {
        const diff = angularDiff(bearing, this.lastBearing);
        anglePassed = diff > rotateAngle;
      }

      if (!anglePassed) return;

      // All checks passed -> apply rotation and save state
      const pluginBearing = (360 - bearing) % 360;
      window.mainmap.setBearing(pluginBearing);
      this.lastBearing = bearing;
      this.lastRotatePoint = [last[0], last[1]];
      this.lastRotateIndex = lastIdx;
    },
    updateGPSPosition(position: GeolocationPosition) {
      const trackOnMap = (this as any)._currentLocationTrackOnMap as L.Polyline | null;
      if (!this.locationActive || !trackOnMap) {
        return;
      }
      this.currentLocation = [position.coords.latitude, position.coords.longitude];
      const track = (this as any)._currentLocationTrack as [number, number][];
      track.push(this.currentLocation);
      trackOnMap.addLatLng(this.currentLocation);
      this.locationMarker.setLatLng(this.currentLocation);
      if (this.followLocation) {
        window.mainmap.panTo(this.currentLocation);
      }
      this.setBearing();
    },
    getCurrentFollowPoint() {
      const endPoint = window.apiHost + 'api/gpspoint/';
      axios.get(endPoint).then((response) => {
        const point = response.data.gpspoint;
        this.followMarker.setLatLng([point.lat, point.lon]);
        const popup = L.popup().setContent(formatTimeSeconds(point.time));
        this.followMarker.bindPopup(popup).openPopup();
      }).catch(() => {

      })
    },
    toggleFollow(e: MouseEvent) {
      if (this.followActive) {
        if (this.followMarker) {
          this.followMarker.removeFrom(window.mainmap);
        }
        clearInterval(this.followInterval);
        this.followActive = false;
      } else {
        if (!this.followMarker) {
          this.followMarker = new L.CircleMarker([0, 0], { radius: 11, fill: true, fillOpacity: 0.5, color: 'red' });
        }
        this.followMarker.setLatLng([0, 0]);
        this.followMarker.addTo(window.mainmap);
        this.followInterval = setInterval(() => {
          this.getCurrentFollowPoint();
        }, 1000);
        this.getCurrentFollowPoint();
        this.followActive = true;
      }
    },
    toggleLocation(e: MouseEvent) {
      if (this.locationActive) {
        if (this.locationMarker) {
          this.locationMarker.removeFrom(window.mainmap);
        }
        const trackOnMap = (this as any)._currentLocationTrackOnMap as L.Polyline | null;
        if (trackOnMap) {
          trackOnMap.removeFrom(window.mainmap);
        }
        (this as any)._currentLocationTrackOnMap = null;
        this.currentLocation = null;
        this.locationActive = false;
        this.followLocation = false;
        (this as any)._currentLocationTrack = [];
        this.lastTime = 0;
        clearInterval(this.locationInterval);
        navigator.geolocation.clearWatch(this.locationWatchID);
        window.mainmap.setBearing(0);
      } else {
        if (!this.locationMarker) {
          this.locationMarker = new L.CircleMarker([0, 0], { radius: 11, fill: true, fillOpacity: 0.5 });
        }
        this.locationMarker.setLatLng([0, 0]);
        this.locationMarker.addTo(window.mainmap);
        this.followLocation = true;
        this.currentLocation = null;
        (this as any)._currentLocationTrack = [];
        const trackOnMap = new L.Polyline([], {
          color: 'red',
          weight: 5,
          opacity: 1,
          smoothFactor: 1,
        });
        (this as any)._currentLocationTrackOnMap = trackOnMap;
        trackOnMap.addTo(window.mainmap);
        this.lastTime = 0;
        if (this.useHTML5location) {
          this.locationWatchID = navigator.geolocation.watchPosition(this.updateGPSPosition);
        } else {
          this.locationInterval = setInterval(() => {
            const date = Date.now();
            debugLog('Running setInterval function with since = ' + this.lastTime + ' (' + this.formatDateMs(this.lastTime) + ') at ' + date + ' (' + this.formatDateMs(date) + ')');
            const rand = this.getRandomInt(1000000);
            this.axiosInstanceForLocalhost.get('http://127.0.0.1:10000/?since=' + this.lastTime + '&rand=' + rand, { timeout: 5000, withCredentials: false }).then((response) => {
              //const response = {'data': {'trackPoints': [{'time': 2 + (this as any)._currentLocationTrack.length, 'lat': 52 + 0.001 * (this as any)._currentLocationTrack.length, 'lon': 18 + 0.001 * (this as any)._currentLocationTrack.length}]}}
              const data = response.data;
              const date2 = Date.now();
              debugLog('Running axios.get then function with since = ' + data.since + ' (' + this.formatDateMs(data.since) + '), responseTimestamp = ' + data.responseTimestamp + ', responseDate = ' + data.responseDate + ' at ' + date2 + ' (' + this.formatDateMs(date2) + '), points: ' + data.trackPoints.length);
              const track = (this as any)._currentLocationTrack as [number, number][];
              const trackOnMap = (this as any)._currentLocationTrackOnMap as L.Polyline | null;
              if (!this.locationActive || !trackOnMap) {
                return;
              }
              let hasNewLocation = false;
              let latLngs = trackOnMap.getLatLngs();
              for (const point of data.trackPoints) {
                if (point.time > this.lastTime) {
                  this.currentLocation = [point.lat, point.lon];
                  const loca = new L.LatLng(point.lat, point.lon);
                  if (track.length == 0) {
                    trackOnMap.addLatLng(loca);
                    latLngs = trackOnMap.getLatLngs();
                  } else {
                    latLngs.push(loca);
                  }
                  track.push(this.currentLocation);
                  this.lastTime = point.time;
                  hasNewLocation = true;
                } else {
                  const date3 = Date.now();
                  debugLog('Skipping adding point (current lastTime = ' + this.lastTime + ') with time = ' + point.time + ' (' + this.formatDateMs(point.time) + ') at ' + date3 + ' (' + this.formatDateMs(date3) + ')');
                }
              }
              if (hasNewLocation) {
                this.setBearing();
                trackOnMap.redraw();
              }
              if (this.currentLocation) {
                this.locationMarker.setLatLng(this.currentLocation);
                if (this.followLocation) {
                  window.mainmap.panTo(this.currentLocation);
                }
              }
            }).catch(() => {
              debugLog('Running axios.get catch function at ' + Date.now());
            })
            const date3 = Date.now();
            debugLog('Ending setInterval function with since = ' + this.lastTime + ' (' + this.formatDateMs(this.lastTime) + ') at ' + date3 + ' (' + this.formatDateMs(date3) + ')');
          }, 1000)
        }
        this.locationActive = true;
      }
      e.stopPropagation();
      this.changeButtonSizeDuringLocation();
      this.lockOrUnlockScreen();
    },
    async addLocationButton() {
      const locationControl = L.Control.extend({
        options: {
          position: 'topright'
        },
        onAdd: (map: L.Map) => {
          return document.getElementById('locationdivinner');
        },
      });
      window.mainmap.addControl(new locationControl());
    },
    async addFollowButton() {
      const followControl = L.Control.extend({
        options: {
          position: 'topright'
        },
        onAdd: (map: L.Map) => {
          return document.getElementById('followdivinner');
        },
      });
      window.mainmap.addControl(new followControl());
    },
    togglePanel(e: MouseEvent) {
      $('#sidebar').toggleClass('sidebaractive');
      this.menuOpened = !this.menuOpened;
      setTimeout(() => {
        window.mainmap.invalidateSize({ pan: false, animate: false });
        this.changeButtonSizeDuringLocation();
      }, 1000);
      e.stopPropagation();
    },
    toggleGalleryPanel(e: MouseEvent) {
      this.mainGalleryOpened = true;
      this.refresh += 1;
      $('#main_gallery_div').toggleClass('active');
      $('#map').toggleClass('small');
      this.galleryOpened = !this.galleryOpened;
      setTimeout(() => {
        window.mainmap.invalidateSize({ pan: false, animate: false });
      }, 1000);
      e.stopPropagation();
    },
    closeFullscreenTooltip() {

    },
    addFullScreenControl() {
      if (window.isDesktop) {
        this.fullScreenControl = new FullScreen({
          position: 'topright',
          title: '',
          titleCancel: '',
          fullscreenElement: document.documentElement,
        }).addTo(window.mainmap);

        window.mainmap.on('enterFullscreen', () => {
          this.fullscreenOpened = true;
          this.closeFullscreenTooltip();
          $(".leaflet-control-zoom-fullscreen").addClass('leaflet-control-zoom-fullscreen_exit').removeClass('leaflet-control-zoom-fullscreen_enter');
        });

        window.mainmap.on('exitFullscreen', () => {
          this.fullscreenOpened = false;
          this.closeFullscreenTooltip();
          $(".leaflet-control-zoom-fullscreen").removeClass('leaflet-control-zoom-fullscreen_exit').addClass('leaflet-control-zoom-fullscreen_enter');
        });
      } else {
        document.onfullscreenchange = (event) => {
          if (document.fullscreenElement) {
            this.fullscreenOpened = true;
          } else {
            this.fullscreenOpened = false;
          }
        };
      }
    },
    toggleFullScreen() {
      if (this.fullScreenControl) {
        this.fullScreenControl.toggleFullScreen();
      } else {
        if (!document.fullscreenElement) {
          document.documentElement.requestFullscreen();
          this.fullscreenOpened = true;
        } else if (document.exitFullscreen) {
          document.exitFullscreen();
          this.fullscreenOpened = false;
        }
      }
    },
    addScaleControl() {
      L.control.scale({ metric: true, position: 'topleft', imperial: false, maxWidth: 200 }).addTo(window.mainmap!);
    },
    openImportFileInput(e: MouseEvent) {
      $('#importFileInput').click();
      e.stopPropagation();
    },
    openAddTrailPhotosInput(e?: MouseEvent) {
      // open hidden file input for adding trail photos
      const input = this.$refs.trailPhotosInput as HTMLInputElement | undefined;
      if (input) {
        input.click();
      }
      if (e) {
        try { e.stopPropagation(); } catch {}
      }
    },
    openSaveTrailPhotos() {
      this.trailPhotosSaveModalOpened = true;
      this.openModal(this.$refs.trailPhotosSaveModal as HTMLElement);
    },
    closeSaveTrailPhotosModal() {
      this.trailPhotosSaveModalOpened = false;
      this.closeModal(this.$refs.trailPhotosSaveModal as HTMLElement);
    },
    async saveTrailPhotos() {
      const itemsToSave = this.trailPhotosModalItems.filter((i: any) => i.selected);
      if (!itemsToSave || itemsToSave.length === 0) {
        this.createAlert(AlertStatus.danger, this.$t('nothingSelected').toString(), 2000);
        return;
      }
      this.trailPhotosSaveTotal = itemsToSave.length;
      this.trailPhotosSaveProgress = 0;
      this.trailPhotosSaveInProgress = true;
      let savedCount = 0;
      for (const item of itemsToSave) {
        try {
          const marker: L.Marker = item.marker;
          const latlng = marker.getLatLng();
          const obj: any = { name: item.name, description: '', type: (item.type && item.type.id) ? item.type.id : null, approved: true, lat: Math.round(latlng.lat * 100000) / 100000, lon: Math.round(latlng.lng * 100000) / 100000, photo_set: [] };
          // create place
          const responsePlace = await axios.post(window.apiHost + `api/places/`, obj);
          const placeId = responsePlace.data.id;
          // upload photo
          let form_data = new FormData();
          form_data.append('name', '');
          form_data.append('description', '');
          form_data.append('org_filename', item.filename);
          form_data.append('place', placeId);
          // private = false
          form_data.append('private', 'false');
          form_data.append('order', '1');
          form_data.append('image', new Blob([new Uint8Array(item.buffer)], { type: 'image/jpeg' }), item.filename);
          let headers = { 'Accept': 'application/json', 'Content-Type': 'multipart/form-data' };
          await axios.post(window.apiHost + 'api/photos/', form_data, { headers: headers });

          // refresh place details and add to store (similar to SavePlaceModal.downloadNewPlace)
          const resp = await axios.get(window.apiHost + 'api/places/' + placeId + '/');
          let responsePlaceData = resp.data;
          const placetype = new PlaceType(responsePlaceData.type.id, responsePlaceData.type.name, responsePlaceData.type.icon, responsePlaceData.type.group);
          const place = new Place(responsePlaceData.id, responsePlaceData.name, responsePlaceData.description, responsePlaceData.lat, responsePlaceData.lon, placetype, responsePlaceData.approved, null, DataOrigin.maplas, true);
          for (const responsePhoto of responsePlaceData.photo_set) {
            const photo = new Photo(responsePhoto.id, responsePhoto.name, responsePhoto.description, responsePhoto.org_filename, responsePhoto.exif_time_taken, window.mediaHost + 'photos/' + responsePhoto.filename, window.mediaHost + 'photos/' + responsePhoto.fullhd_filename, window.mediaHost + 'photos/' + responsePhoto.thumb_filename, responsePhoto.private, responsePhoto.order, responsePhoto.past);
            place.addPhoto(photo);
          }
          this.$store.commit('addPlace', place);
          for (const storePlace of this.$store.state.places) {
            if (storePlace.id == place.id) {
              storePlace.createMarker();
            }
          }
          // notify UI to rebuild place groups and show markers
          try { EventBus.$emit('RefreshPlacesGroups'); } catch (e) {}
          // remove marker and modal item from lists
          try { marker.remove(); } catch (e) {}
          try { if (item.url) URL.revokeObjectURL(item.url); } catch (e) {}
          // remove from non-reactive marker list
          // @ts-ignore
          for (let mi = 0; mi < this._trailPhotoMarkers.length; mi++) {
            // @ts-ignore
            if (this._trailPhotoMarkers[mi].marker === marker) {
              // @ts-ignore
              this._trailPhotoMarkers.splice(mi, 1);
              break;
            }
          }
          const idx = this.trailPhotosModalItems.indexOf(item);
          if (idx >= 0) this.trailPhotosModalItems.splice(idx, 1);

          savedCount++;
          this.trailPhotosSaveProgress = Math.round((savedCount / this.trailPhotosSaveTotal) * 100);
        } catch (err) {
          debugError(err);
          this.createAlert(AlertStatus.danger, this.$t('photoSavedError').toString(), 4000);
          this.trailPhotosSaveInProgress = false;
          return;
        }
      }
      this.trailPhotosSaveInProgress = false;
      if (this.trailPhotosModalItems.length === 0) {
        this.trailPhotosAdded = false;
        this.closeSaveTrailPhotosModal();
      }
    },
    hasSelectedTrailPhotos(): boolean {
      try {
        return this.trailPhotosModalItems && this.trailPhotosModalItems.some((i: any) => i.selected);
      } catch (e) {
        return false;
      }
    },
    readFileAsArrayBuffer(file: File) {
      return new Promise<ArrayBuffer>((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (ev: ProgressEvent<FileReader>) => {
          // @ts-ignore
          resolve(ev.target.result);
        };
        reader.onerror = (ev) => {
          reject(ev);
        };
        reader.readAsArrayBuffer(file);
      });
    },
    async importTrailPhotos(event: Event) {
      const files = (event.target as HTMLInputElement).files;
      if (!files || files.length === 0) {
        return;
      }
      // remember existing marker count so we can fit bounds only for newly added markers
      // @ts-ignore
      const existingMarkersLen = (this._trailPhotoMarkers && this._trailPhotoMarkers.length) ? this._trailPhotoMarkers.length : 0;
      let successCount = 0;
      let noExifCount = 0;
      let readErrorCount = 0;
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        try {
          const buffer = await this.readFileAsArrayBuffer(file);
          let exifData: any = null;
          try {
            exifData = await ExifReader.load(buffer, { expanded: true });
          } catch (e) {
            exifData = null;
          }
          let lat: number | null = null;
          let lon: number | null = null;
          let timeTakenStr: string | null = null;
          let timeTakenDate: Date | null = null;
          try {
            const gps = exifData && (exifData.gps || exifData.GPS);
            if (gps) {
              let gLon = gps.Longitude || gps.LongitudeRef || gps.GPSLongitude || gps.lon;
              let gLat = gps.Latitude || gps.LatitudeRef || gps.GPSLatitude || gps.lat;
              if (gLon && typeof gLon === 'object' && 'description' in gLon) gLon = gLon.description;
              if (gLat && typeof gLat === 'object' && 'description' in gLat) gLat = gLat.description;
              lon = Number(gLon);
              lat = Number(gLat);
            }
            // try to extract EXIF datetime from common tags
            try {
              const exifRoot = exifData && (exifData.exif || exifData.EXIF || exifData.image || exifData);
              const dateKeys = ['DateTimeOriginal', 'DateTime', 'DateTimeDigitized', 'CreateDate', 'DateCreated'];
              for (const k of dateKeys) {
                if (exifRoot && (k in exifRoot)) {
                  let v: any = exifRoot[k];
                  if (v && typeof v === 'object') {
                    if ('description' in v) v = v.description;
                    else if ('value' in v) v = v.value;
                  }
                  if (v && typeof v === 'string') {
                    // try parse common EXIF string formats like YYYY:MM:DD HH:MM:SS
                    const m1 = moment(v, 'YYYY:MM:DD HH:mm:ss', true);
                    if (m1.isValid()) {
                      timeTakenDate = m1.toDate();
                      break;
                    }
                    const m2 = moment(v);
                    if (m2.isValid()) {
                      timeTakenDate = m2.toDate();
                      break;
                    }
                  }
                }
              }
            } catch (e) {}
          } catch (e) {
            lat = null;
            lon = null;
          }
          if ((lat === null) || (lon === null) || !isFinite(lat) || !isFinite(lon)) {
            noExifCount = noExifCount + 1;
            continue;
          }

          // create blob url for image preview and keep buffer for uploads
          const blob = new Blob([buffer], { type: file.type || 'image/jpeg' });
          const url = URL.createObjectURL(blob);

          // create marker with camera icon (anchor at center so icon center indicates location), draggable
          const markerIcon = L.icon({ iconUrl: icons.camera, iconSize: [36, 36], iconAnchor: [18, 18] });
          const marker = L.marker([lat, lon], { icon: markerIcon, contextmenu: false, contextmenuItems: [], draggable: true }).addTo(window.mainmap);

          // create DOM image inside a padded wrapper so popup close button sits above the image
          const wrapper = document.createElement('div');
          wrapper.style.position = 'relative';
          wrapper.style.paddingTop = '28px';
          wrapper.style.textAlign = 'center';
          const header = document.createElement('div');
          header.style.position = 'absolute';
          header.style.top = '0';
          header.style.left = '0';
          header.style.right = '0';
          header.style.height = '28px';
          header.style.display = 'flex';
          header.style.alignItems = 'center';
          header.style.justifyContent = 'space-between';
          header.style.padding = '0 6px';
          header.style.fontSize = '12px';
          header.style.overflow = 'hidden';
          header.style.whiteSpace = 'nowrap';
          header.style.textOverflow = 'ellipsis';
          // filename and time (if available)
          let headerLeft = document.createElement('div');
          headerLeft.style.flex = '1 1 auto';
          headerLeft.style.textAlign = 'left';
          headerLeft.style.overflow = 'hidden';
          headerLeft.style.textOverflow = 'ellipsis';
          headerLeft.style.paddingRight = '8px';
          let timeStr = '';
          if (timeTakenDate) {
            timeStr = moment(timeTakenDate).format('YYYY.MM.DD H:mm:ss');
          }
          // undo button (hidden until marker moved)
          const undoBtn = document.createElement('img');
          undoBtn.src = icons.undo;
          undoBtn.style.height = '16px';
          undoBtn.style.cursor = 'pointer';
          undoBtn.style.display = 'none';
          undoBtn.style.marginRight = '6px';
          undoBtn.onclick = () => {
            try {
              marker.setLatLng([lat, lon]);
            } catch (e) {}
            // mark as not changed
            try { markerEntry.changed = false; } catch (e) {}
            undoBtn.style.display = 'none';
          };
          const nameSpan = document.createElement('span');
          nameSpan.style.display = 'inline-block';
          nameSpan.style.overflow = 'hidden';
          nameSpan.style.textOverflow = 'ellipsis';
          nameSpan.innerText = file.name + (timeStr ? (' — ' + timeStr) : '');
          headerLeft.appendChild(undoBtn);
          headerLeft.appendChild(nameSpan);
          header.appendChild(headerLeft);
          wrapper.appendChild(header);
          const imgEl = document.createElement('img');
          imgEl.src = url;
          imgEl.style.maxWidth = '500px';
          imgEl.style.maxHeight = '500px';
          imgEl.style.display = 'block';
          imgEl.style.margin = '0';
          imgEl.onload = () => {
            try { marker.getPopup()?.update(); } catch (e) {}
          };
          wrapper.appendChild(imgEl);
          marker.bindPopup(wrapper, { maxWidth: 520 });

          // store non-reactive marker + url + buffer for cleanup and upload
          // @ts-ignore
          const markerEntry: any = { marker: marker, url: url, filename: file.name, buffer: buffer, origLat: lat, origLon: lon, changed: false };
          // @ts-ignore
          this._trailPhotoMarkers.push(markerEntry);

          // show undo button when marker moved
          marker.on('dragend', () => {
            try {
              markerEntry.changed = true;
              undoBtn.style.display = 'inline-block';
            } catch (e) {}
          });

          // determine default place type object (prefer 'road' if present)
          let defaultTypeObj: any = null;
          try {
            const pts = this.$store.state.placeTypes;
            if (pts && pts.length) {
              const found = pts.find((p: any) => p.name === 'road');
              defaultTypeObj = found ? found : pts[0];
            }
          } catch (e) {}
          // add reactive entry for modal listing (default name 'Droga') and keep buffer + marker reference
          this.trailPhotosModalItems.push({ url: url, selected: true, filename: file.name, type: defaultTypeObj, name: 'Droga', buffer: buffer, marker: marker });
          successCount = successCount + 1;
        } catch (err) {
          readErrorCount = readErrorCount + 1;
        }
      }

      const failed = noExifCount + readErrorCount;
      if (failed > 0) {
        const parts: string[] = [];
        if (noExifCount) parts.push(this.$t('trailPhotos_no_exif', [noExifCount]).toString());
        if (readErrorCount) parts.push(this.$t('trailPhotos_read_errors', [readErrorCount]).toString());
        parts.push(this.$t('trailPhotos_markers_created', [successCount]).toString());
        this.createAlert(AlertStatus.danger, parts.join('; '), 6000);
      } else {
        this.createAlert(AlertStatus.success, this.$t('trailPhotos_processed_success', [successCount, successCount]).toString(), 4000);
      }
      if (successCount > 0) {
        this.trailPhotosAdded = true;
      }
      // fit map to newly added markers
      try {
        // @ts-ignore
        const markersArr: any[] = (this._trailPhotoMarkers && this._trailPhotoMarkers.length) ? this._trailPhotoMarkers : [];
        const totalMarkers = markersArr.length;
        // only fit bounds for markers added in this import
        if (totalMarkers > existingMarkersLen) {
          const latlngs: L.LatLngExpression[] = [];
          for (let mi = existingMarkersLen; mi < totalMarkers; mi++) {
            try { latlngs.push(markersArr[mi].marker.getLatLng()); } catch (e) {}
          }
          if (latlngs.length > 0) {
            const bounds = new L.LatLngBounds(latlngs as any);
            try { window.mainmap.fitBounds(bounds, { padding: [40, 40] }); } catch (e) {}
          }
        }
      } catch (e) {}
      // reset input
      const input = this.$refs.trailPhotosInput as HTMLInputElement | undefined;
      if (input) input.value = '';
    },
    clearTrailPhotos() {
      // @ts-ignore
      if (!this._trailPhotoMarkers || this._trailPhotoMarkers.length === 0) {
        this.trailPhotosAdded = false;
        return;
      }
      // @ts-ignore
      const len = this._trailPhotoMarkers.length;
      // @ts-ignore
      for (const entry of this._trailPhotoMarkers) {
        try { entry.marker.remove(); } catch (e) {}
        try { if (entry.url) URL.revokeObjectURL(entry.url); } catch (e) {}
      }
      // @ts-ignore
      this._trailPhotoMarkers.length = 0;
      // clear modal list
      this.trailPhotosModalItems.length = 0;
      this.trailPhotosAdded = false;
      this.createAlert(AlertStatus.success, this.$t('trailPhotos_cleared', [len]).toString(), 2000);
    },
    fixParse(gpxString: string) {
      let gpx: { 'trk': { 'name': string, 'desc': string, 'trkseg': { 'trkpt': { 'time': string, '$': { lat: number, lon: number } }[] }[] }[] };
      xml2js.parseString(
        gpxString,
        {
          explicitArray: false,
        },
        (err, xml) => {
          if (err) {
            return;
          }
          if (!xml.gpx) {
            return;
          }

          gpx = new GPX({
            attributes: xml.gpx.$,
            metadata: xml.gpx.metadata,
            wpt: xml.gpx.wpt,
            rte: xml.gpx.rte,
            trk: xml.gpx.trk,
          });
        }
      );

      return gpx;
    },
    importGpxFileNew(event: Event) {
      let trackIndex = 0;
      const startIndex = new Date().getTime();
      const files = (event.target! as HTMLInputElement).files;
      if (!files || !files.length) {
        this.createAlert(AlertStatus.danger, this.$t('importNoFiles').toString(), 2000);
        return;
      }
      for (const file of files) {
        const reader = new FileReader();
        reader.readAsText(file);
        reader.onload = (onLoadEvent: Event) => {
          const gpxFileString = (onLoadEvent.target! as FileReaderEventTarget).result;
          const gpx = this.fixParse(gpxFileString);
          if (!gpx) {
            this.createAlert(AlertStatus.danger, this.$t('importError').toString(), 2000);
          } else {
            let atLeasyOneTrack = false;
            for (const fileTrack of gpx.trk) {
              atLeasyOneTrack = true;
              trackIndex = trackIndex + 1;
              let distance = 0;
              let startTime = '';
              let endTime = '';
              const segments = [];
              for (const segment of fileTrack.trkseg) {
                const pointsArray = [];
                let lastPoint = null;
                for (const point of segment.trkpt) {
                  const newPoint = [Number(point.$.lat), Number(point.$.lon)];
                  pointsArray.push(newPoint);
                  if (!startTime) {
                    startTime = point.time;
                  }
                  endTime = point.time;
                  if (lastPoint) {
                    distance = distance + distanceBetweenPoints(lastPoint[0], lastPoint[1], newPoint[0], newPoint[1]);
                  }
                  lastPoint = newPoint;
                }
                segments.push(pointsArray);
              }
              const newGpstrack: GpsTrack = new GpsTrack(startIndex + trackIndex, fileTrack.name, fileTrack.desc, JSON.stringify(segments), '#FF0000', distance, null, TrackStatus.done, TrackType.bicycle, startTime ? new Date(startTime) : null, endTime ? new Date(endTime) : null, gpxFileString, undefined, 1);
              const track = new Track(newGpstrack, true, false);
              this.$store.commit('addImportedTrack', track);
              track.createMapObjects(window.mainmap);
              const documentObject = window.tracks[track.id]
              const trackBounds = new L.LatLngBounds(documentObject.mapTracks[0].getBounds().getNorthEast(), documentObject.mapTracks[0].getBounds().getSouthWest());
              for (const mapTrack of documentObject.mapTracks) {
                trackBounds.extend(mapTrack.getBounds());
              }
              window.mainmap.fitBounds(trackBounds);
            }
            if (atLeasyOneTrack) {
              this.createAlert(AlertStatus.success, this.$t('importSuccess').toString(), 2000);
            } else {
              this.createAlert(AlertStatus.danger, this.$t('importNoTracks').toString(), 2000);
            }
          }
          this.importGpxFileCount = this.importGpxFileCount + 1;
        };
        reader.onerror = (onErrorEvent: Event) => {
          this.createAlert(AlertStatus.danger, this.$t('importError').toString(), 2000);
          this.importGpxFileCount = this.importGpxFileCount + 1;
        };
      }
    },
    downloadRegions() {
      const endPoint = window.apiHost + 'api/regions/';
      let config;
      [config, this.regionsAbortController] = this.createAbortConfig();
      this.regionsLoading = true;
      this.downloadUrlWithCache(endPoint, 'main', 'regions.txt', config, !this.startOfflineClicked).then((response) => {
        if (response[0] == DownloadStatus.cache_fresh) {
          this.createAlert(AlertStatus.success, this.$t('regionsLoaded', [response[1].results.length]).toString(), 2000);
        }
        if (response[0] == DownloadStatus.api_fresh) {
          this.createAlert(AlertStatus.success, this.$t('regionsDownloaded', [response[1].results.length]).toString(), 2000);
        }
        if (response[0] == DownloadStatus.cache_last) {
          this.createAlert(AlertStatus.warning, this.$t('regionsLoaded', [response[1].results.length]).toString(), 2000);
        }
        const regions = [];
        for (const responseRegion of response[1].results) {
          const region = new Region(responseRegion.id, responseRegion.name);
          this.$store.commit('addTranslation', { lang: 'pl', key: responseRegion.name, value: responseRegion.pl })
          this.$store.commit('addTranslation', { lang: 'en', key: responseRegion.name, value: responseRegion.en })
          regions.push(region);
        }
        this.$store.commit('setRegions', regions);
      }).catch((response) => {
        this.createAlert(AlertStatus.danger, this.$t('regionsError').toString(), 2000);
      }).finally(() => {
        this.regionsLoading = false;
      });
    },
    processPlaces(results: any) {
      const places = [];
      for (const responsePlace of results) {
        const placetype = new PlaceType(responsePlace.type.id, responsePlace.type.name, responsePlace.type.icon, responsePlace.type.group);
        const place = new Place(responsePlace.id, responsePlace.name, responsePlace.description, responsePlace.lat, responsePlace.lon, placetype, responsePlace.approved, null, DataOrigin.maplas, true);
        for (const responsePhoto of responsePlace.photo_set) {
          const photo = new Photo(responsePhoto.id, responsePhoto.name, responsePhoto.description, responsePhoto.org_filename, responsePhoto.exif_time_taken, window.mediaHost + 'photos/' + responsePhoto.filename, window.mediaHost + 'photos/' + responsePhoto.fullhd_filename, window.mediaHost + 'photos/' + responsePhoto.thumb_filename, responsePhoto.private, responsePhoto.order, responsePhoto.past);
          place.addPhoto(photo);
        }
        for (const responseVideoLink of responsePlace.videolink_set) {
          const video = new VideoLink(responseVideoLink.id, responseVideoLink.name, responseVideoLink.description, responseVideoLink.link, responseVideoLink.html);
          place.addVideo(video);
        }
        places.push(place);
      }
      this.$store.commit('setPlaces', places);
      for (const place of this.$store.state.places) {
        place.createMarker();
      }
    },
    downloadPlaces() {
      const endPoint = window.apiHost + 'api/places/';
      let config;
      [config, this.placesAbortController] = this.createAbortConfig();
      this.placesLoading = true;
      this.downloadUrlWithCache(endPoint, 'main', 'places.txt', config, !this.startOfflineClicked).then((response) => {
        if (response[0] == DownloadStatus.cache_fresh) {
          this.createAlert(AlertStatus.success, this.$t('placesLoaded', [response[1].results.length]).toString(), 2000);
        }
        if (response[0] == DownloadStatus.api_fresh) {
          this.createAlert(AlertStatus.success, this.$t('placesDownloaded', [response[1].results.length]).toString(), 2000);
        }
        if (response[0] == DownloadStatus.cache_last) {
          this.createAlert(AlertStatus.warning, this.$t('placesLoaded', [response[1].results.length]).toString(), 2000);
        }
        this.processPlaces(response[1].results);
        //Opoznienie ponieważ może zakłócić wczytanie danych początkowych z Cache!
        setTimeout(this.startThumbsCacheForPlaces, 30000);
      }).catch((response) => {
        this.createAlert(AlertStatus.danger, this.$t('placesError').toString(), 2000);
      }).finally(() => {
        this.placesLoading = false;
      });
    },
    downloadPlaceTypes() {
      const endPoint = window.apiHost + 'api/placetypes/';
      let config;
      [config, this.placeTypesAbortController] = this.createAbortConfig();
      this.placeTypesLoading = true;
      this.downloadUrlWithCache(endPoint, 'main', 'placetypes.txt', config, !this.startOfflineClicked).then((response) => {
        if (response[0] == DownloadStatus.cache_fresh) {
          this.createAlert(AlertStatus.success, this.$t('placeTypesLoaded', [response[1].results.length]).toString(), 2000);
        }
        if (response[0] == DownloadStatus.api_fresh) {
          this.createAlert(AlertStatus.success, this.$t('placeTypesDownloaded', [response[1].results.length]).toString(), 2000);
        }
        if (response[0] == DownloadStatus.cache_last) {
          this.createAlert(AlertStatus.warning, this.$t('placeTypesLoaded', [response[1].results.length]).toString(), 2000);
        }
        const placeTypes = [];
        for (const responsePlaceType of response[1].results) {
          const placeType = new PlaceType(responsePlaceType.id, responsePlaceType.name, responsePlaceType.icon, responsePlaceType.group);
          this.$store.commit('addTranslation', { lang: 'pl', key: responsePlaceType.name, value: responsePlaceType.pl })
          this.$store.commit('addTranslation', { lang: 'en', key: responsePlaceType.name, value: responsePlaceType.en })
          placeTypes.push(placeType);
        }
        this.$store.commit('setPlaceTypes', placeTypes);
      }).catch((response) => {
        this.createAlert(AlertStatus.danger, this.$t('placeTypesError').toString(), 2000);
      }).finally(() => {
        this.placeTypesLoading = false;
      })
    },
    refreshPhotos() {
      const endPoint = window.apiHost + 'api/tracks/' + (import.meta.env.VITE_TRACKS_QUERY || '');
      axios.get(endPoint).then((response) => {
        for (const gpstrack of response.data.results) {
          for (const currentTrack of this.$store.state.tracks) {
            if (gpstrack.id === currentTrack.gpsTrack.id) {
              currentTrack.gpsTrack.photos = [];
              for (const responsePhoto of gpstrack.photo_set) {
                const photo = new Photo(responsePhoto.id, responsePhoto.name, responsePhoto.description, responsePhoto.org_filename, responsePhoto.exif_time_taken, window.mediaHost + 'photos/' + responsePhoto.filename, window.mediaHost + 'photos/' + responsePhoto.fullhd_filename, window.mediaHost + 'photos/' + responsePhoto.thumb_filename, responsePhoto.private, responsePhoto.order, responsePhoto.past);
                currentTrack.gpsTrack.addPhoto(photo);
              }
            }
          }
        }
      })
    },
    processTracks(results: any) {
      const tracks = [];
      const plannedTracks = [];
      const borderTracks = [];
      const trailTracks = [];
      const eventTracks = [];
      const otherPeopleTracks = [];
      for (const gpstrack of results) {
        try {
          const region: Region = gpstrack.region ? new Region(gpstrack.region.id, gpstrack.region.name) : undefined;
          const newGpstrack: GpsTrack = new GpsTrack(gpstrack.id, gpstrack.name, gpstrack.description, gpstrack.points_json_optimized, gpstrack.color ? gpstrack.color : '#ff0000', gpstrack.distance, gpstrack.elevation_gain, gpstrack.status, gpstrack.type, gpstrack.start_time ? new Date(gpstrack.start_time) : null, gpstrack.end_time ? new Date(gpstrack.end_time) : null, undefined, region, gpstrack.style);
          let checked = false;
          if (typeof this.$route.query.tracks === 'string') {
            const tracksIds = this.$route.query.tracks.split(',');
            checked = tracksIds.includes(String(gpstrack.id));
          } else {
            if (newGpstrack.status === TrackStatus.done) {
              checked = true;
            } else {
              checked = false;
            }
          }
          const track = new Track(newGpstrack, checked, true);
          for (const responsePhoto of gpstrack.photo_set) {
            const photo = new Photo(responsePhoto.id, responsePhoto.name, responsePhoto.description, responsePhoto.org_filename, responsePhoto.exif_time_taken, window.mediaHost + 'photos/' + responsePhoto.filename, window.mediaHost + 'photos/' + responsePhoto.fullhd_filename, window.mediaHost + 'photos/' + responsePhoto.thumb_filename, responsePhoto.private, responsePhoto.order, responsePhoto.past);
            newGpstrack.addPhoto(photo);
          }
          for (const responseVideoLink of gpstrack.videolink_set) {
            const video = new VideoLink(responseVideoLink.id, responseVideoLink.name, responseVideoLink.description, responseVideoLink.link, responseVideoLink.html);
            newGpstrack.addVideo(video);
          }
          if (newGpstrack.isDoneTrack()) {
            tracks.push(track);
          }
          if (newGpstrack.isPlannedTrack()) {
            plannedTracks.push(track);
          }
          if (newGpstrack.isTrailTrack()) {
            trailTracks.push(track);
          }
          if (newGpstrack.isBorderTrack()) {
            borderTracks.push(track);
          }
          if (newGpstrack.isOtherPeopleTrack()) {
            otherPeopleTracks.push(track);
          }
          if (newGpstrack.isEventTrack()) {
            eventTracks.push(track);
          }
        } catch (error) {
          debugError(error)
          this.createAlert(AlertStatus.danger, this.$t('oneTrackError').toString(), 2000);
        }
      }
      this.$store.commit('setTracks', tracks);
      this.$store.commit('setPlannedTracks', plannedTracks);
      this.$store.commit('setTrailTracks', trailTracks);
      this.$store.commit('setBorderTracks', borderTracks);
      this.$store.commit('setOtherPeopleTracks', otherPeopleTracks);
      this.$store.commit('setEventTracks', eventTracks);
      this.$store.commit('setTmpPlannedTracks', []);
      for (const track of this.$store.state.tracks) {
        track.createMapObjects(window.mainmap);
      }
      for (const track of this.$store.state.plannedTracks) {
        track.createMapObjects(window.mainmap);
      }
      for (const track of this.$store.state.trailTracks) {
        track.createMapObjects(window.mainmap);
      }
      for (const track of this.$store.state.borderTracks) {
        track.createMapObjects(window.mainmap);
      }
      for (const track of this.$store.state.otherPeopleTracks) {
        track.createMapObjects(window.mainmap);
      }
      for (const track of this.$store.state.eventTracks) {
        track.createMapObjects(window.mainmap);
      }
    },
    downloadTracks() {
      const endPoint = window.apiHost + 'api/tracks/' + (import.meta.env.VITE_TRACKS_QUERY || '');
      let config;
      [config, this.tracksAbortController] = this.createAbortConfig();
      this.tracksLoading = true;
      this.downloadUrlWithCache(endPoint, 'main', 'tracks.txt', config, !this.startOfflineClicked).then((response) => {
        if (response[0] == DownloadStatus.cache_fresh) {
          this.createAlert(AlertStatus.success, this.$t('tracksLoaded', [response[1].results.length]).toString(), 2000);
        }
        if (response[0] == DownloadStatus.api_fresh) {
          this.createAlert(AlertStatus.success, this.$t('tracksDownloaded', [response[1].results.length]).toString(), 2000);
        }
        if (response[0] == DownloadStatus.cache_last) {
          this.createAlert(AlertStatus.warning, this.$t('tracksLoaded', [response[1].results.length]).toString(), 2000);
        }
        this.processTracks(response[1].results);
        //Opoznienie ponieważ może zakłócić wczytanie danych początkowych z Cache!
        setTimeout(this.startThumbsCacheForTracks, 30000);
      }).catch(() => {
        this.createAlert(AlertStatus.danger, this.$t('tracksError').toString(), 2000);
      }).finally(() => {
        this.tracksLoading = false;
      });
    },
    onSpeedScaleChooseChange() {
      this.$store.commit('setSpeedScale', this.speedScaleChoose);
    },
    onLanguageChanged() {
      // @ts-ignore
      i18n.global.locale = this.language!.language;
      for (const list of listTranslator) {
        this.translateArray(list);
      }
    },
    onRotateDuringNavigation() {
      if ((this.rotateDuringNavigation !== null) && (typeof this.rotateDuringNavigation !== "undefined")) {
        localStorage.setItem('rotateDuringNavigation', this.rotateDuringNavigation.toString());
      }
      if (this.rotateDuringNavigation) {
        this.setBearing();
      } else {
        window.mainmap.setBearing(0);
      }
    },
    onUseHTML5location() {
      if ((this.useHTML5location !== null) && (typeof this.useHTML5location !== "undefined")) {
        localStorage.setItem('useHTML5location', this.useHTML5location.toString());
      }
    },
    onLargeButtonsDuringLocation() {
      if ((this.largeButtonsDuringLocation !== null) && (typeof this.largeButtonsDuringLocation !== "undefined")) {
        localStorage.setItem('largeButtonsDuringLocation', this.largeButtonsDuringLocation.toString());
        this.changeButtonSizeDuringLocation();
      }
    },
    onshowAllButtonsDuringLocation() {
      if ((this.showAllButtonsDuringLocation !== null) && (typeof this.showAllButtonsDuringLocation !== "undefined")) {
        localStorage.setItem('showAllButtonsDuringLocation', this.showAllButtonsDuringLocation.toString());
        this.changeButtonSizeDuringLocation();
      }
    },
    onLockPortrait() {
      localStorage.setItem('lockPortrait', this.lockPortrait.toString());
      this.lockOrUnlockScreen();
    },
    onStoreTracksChanged() {
      for (const group of this.groups) {
        this.trackGroupsDict[group.id] = group.grouper.groupTracks(this.$store.state.tracks);
      }
    },
    onStoreImportsChanged() {
      this.importGroup.tracks = [];
      for (const track of this.$store.state.imports) {
        this.importGroup.tracks.push(track);
      }
    },
    redrawLayers() {
      for(const layer in window.overlayLayers) {
        window.overlayLayers[layer].redraw();
      }
    },
    adjustRangeMin() {
      if (this.paletteMin > this.paletteMax) {
        this.$nextTick(() => {
          this.paletteMin = this.paletteMax;
          window.paletteMin = this.paletteMin;
        })
      }
    },
    adjustRangeMax() {
      if (this.paletteMax < this.paletteMin) {
        this.$nextTick(() => {
          this.paletteMax = this.paletteMin;
          window.paletteMax = this.paletteMax;
        })
      }
    }
  },
  computed: {
    uniformTrackColorValue(): string {
      return this.getUniformTrackColor();
    }
  },
  watch: {
    paletteChoose(newPalette: number, oldPalette: number) {
      window.paletteIndex = newPalette;
      this.redrawLayers();
    },
    paletteMin(newMin: number, oldMin: number) {
      window.paletteMin = newMin;
      if (! this.waitingForRedraw) {
        this.waitingForRedraw = true;
        setTimeout(() => {
          this.waitingForRedraw = false;
          this.redrawLayers();
        }, 500);
      }
    },
    paletteMax(newMax: number, oldMax: number) {
      window.paletteMax = newMax;
      if (! this.waitingForRedraw) {
        this.waitingForRedraw = true;
        setTimeout(() => {
          this.waitingForRedraw = false;
          this.redrawLayers();
        }, 500);
      }
    },
    binaryLayerAlpha(newAlpha: number, oldAlpha: number) {
      window.binaryLayerAlpha = newAlpha;
      if (! this.waitingForRedraw) {
        this.waitingForRedraw = true;
        setTimeout(() => {
          this.waitingForRedraw = false;
          this.redrawLayers();
        }, 500);
      }
    },
    "speedScaleChoose": [{
      handler: "onSpeedScaleChooseChange"
    }],
    "language": [{
      handler: "onLanguageChanged"
    }],
    "useHTML5location": [{
      handler: "onUseHTML5location"
    }],
    "rotateDuringNavigation": [{
      handler: "onRotateDuringNavigation"
    }],
    "largeButtonsDuringLocation": [{
      handler: "onLargeButtonsDuringLocation"
    }],
    "showAllButtonsDuringLocation": [{
      handler: "onshowAllButtonsDuringLocation"
    }],
    "lockPortrait": [{
      handler: "onLockPortrait"
    }],
    "$store.state.tracks": [{
      handler: "onStoreTracksChanged"
    }],
    "$store.state.imports": [{
      handler: "onStoreImportsChanged"
    }],
  }
})

</script>

<style>
body {
  margin: 0;
}

#appvue {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

#map {
  position: relative;
  height: 100%;
  width: 100%;
}

#map.small {
  width: 0% !important;
}

.wrapper {
  display: flex;
  width: 100%;
  height: 100%;
  align-items: stretch;
}

.content {
  min-height: 100vh;
  width: 100%;
  display: flex;
}

.sidebar {
  min-width: 460px;
  max-width: 460px;
  min-height: 100vh;
  max-height: 100vh;
  margin-left: -460px;
  transition: margin-left 0.5s linear;
  background-color: white;
  overflow: scroll;
}

@media (min-width: 400px) {
  .sidebarpwa {
    min-width: 400px;
    max-width: 400px;
    min-height: 100vh;
    max-height: 100vh;
    margin-left: -400px;
    background-color: white;
    overflow: scroll;
  }
}

@media (max-width: 400px) {
  .sidebarpwa {
    min-width: 100%;
    max-width: 100%;
    min-height: 100vh;
    max-height: 100vh;
    margin-left: -100%;
    background-color: white;
    overflow: scroll;
  }
}

.sidebaractive {
  margin-left: 0 !important;
}

#main_gallery_div {
  display: none;
}

#main_gallery_div.active {
  display: block !important;
  padding: 0px;
  height: 100%;
  width: 100%;
  background-image: url(../assets/gallery_background.jpg);
  background-size: 100% auto;
}

.centerloading {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 3000000;
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

.cogsbutton {
  height: 34px;
  width: 34px;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
}

.leaflet-control-zoom-fullscreen {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' version='1.1' width='1000' height='1000' viewBox='0 0 1000 1000' xml:space='preserve'%3E%3Cdesc%3ECreated with Fabric.js 3.5.0%3C/desc%3E%3Cdefs%3E%3C/defs%3E%3Crect x='0' y='0' width='100%25' height='100%25' fill='rgba(255,255,255,0)'/%3E%3Cg transform='matrix(1.4208 0 0 1.4208 500.014 500.014)' id='216632'%3E%3Cg style='' vector-effect='non-scaling-stroke'%3E%3Cg transform='matrix(33.3333 0 0 33.3333 -216.6668 -216.6668)'%3E%3Cpath style='stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; is-custom-font: none; font-file-url: none; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;' transform=' translate(-5.5, -5.5)' d='M 4 1.5 C 2.61929 1.5 1.5 2.61929 1.5 4 V 8.5 C 1.5 9.05228 1.94772 9.5 2.5 9.5 H 3.5 C 4.05228 9.5 4.5 9.05228 4.5 8.5 V 4.5 H 8.5 C 9.05228 4.5 9.5 4.05228 9.5 3.5 V 2.5 C 9.5 1.94772 9.05228 1.5 8.5 1.5 H 4 Z' stroke-linecap='round'/%3E%3C/g%3E%3Cg transform='matrix(33.3333 0 0 33.3333 216.6666 -216.6668)'%3E%3Cpath style='stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; is-custom-font: none; font-file-url: none; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;' transform=' translate(-18.5, -5.5)' d='M 20 1.5 C 21.3807 1.5 22.5 2.61929 22.5 4 V 8.5 C 22.5 9.05228 22.0523 9.5 21.5 9.5 H 20.5 C 19.9477 9.5 19.5 9.05228 19.5 8.5 V 4.5 H 15.5 C 14.9477 4.5 14.5 4.05228 14.5 3.5 V 2.5 C 14.5 1.94772 14.9477 1.5 15.5 1.5 H 20 Z' stroke-linecap='round'/%3E%3C/g%3E%3Cg transform='matrix(33.3333 0 0 33.3333 216.6666 216.6666)'%3E%3Cpath style='stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; is-custom-font: none; font-file-url: none; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;' transform=' translate(-18.5, -18.5)' d='M 20 22.5 C 21.3807 22.5 22.5 21.3807 22.5 20 V 15.5 C 22.5 14.9477 22.0523 14.5 21.5 14.5 H 20.5 C 19.9477 14.5 19.5 14.9477 19.5 15.5 V 19.5 H 15.5 C 14.9477 19.5 14.5 19.9477 14.5 20.5 V 21.5 C 14.5 22.0523 14.9477 22.5 15.5 22.5 H 20 Z' stroke-linecap='round'/%3E%3C/g%3E%3Cg transform='matrix(33.3333 0 0 33.3333 -216.6668 216.6666)'%3E%3Cpath style='stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; is-custom-font: none; font-file-url: none; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;' transform=' translate(-5.5, -18.5)' d='M 1.5 20 C 1.5 21.3807 2.61929 22.5 4 22.5 H 8.5 C 9.05228 22.5 9.5 22.0523 9.5 21.5 V 20.5 C 9.5 19.9477 9.05228 19.5 8.5 19.5 H 4.5 V 15.5 C 4.5 14.9477 4.05228 14.5 3.5 14.5 H 2.5 C 1.94772 14.5 1.5 14.9477 1.5 15.5 V 20 Z' stroke-linecap='round'/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E") !important;
  background-size: cover;
  background-origin: content-box;
  padding: 8px;
}

.leaflet-control-zoom-fullscreen_enter {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' version='1.1' width='1000' height='1000' viewBox='0 0 1000 1000' xml:space='preserve'%3E%3Cdesc%3ECreated with Fabric.js 3.5.0%3C/desc%3E%3Cdefs%3E%3C/defs%3E%3Crect x='0' y='0' width='100%25' height='100%25' fill='rgba(255,255,255,0)'/%3E%3Cg transform='matrix(1.4208 0 0 1.4208 500.014 500.014)' id='216632'%3E%3Cg style='' vector-effect='non-scaling-stroke'%3E%3Cg transform='matrix(33.3333 0 0 33.3333 -216.6668 -216.6668)'%3E%3Cpath style='stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; is-custom-font: none; font-file-url: none; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;' transform=' translate(-5.5, -5.5)' d='M 4 1.5 C 2.61929 1.5 1.5 2.61929 1.5 4 V 8.5 C 1.5 9.05228 1.94772 9.5 2.5 9.5 H 3.5 C 4.05228 9.5 4.5 9.05228 4.5 8.5 V 4.5 H 8.5 C 9.05228 4.5 9.5 4.05228 9.5 3.5 V 2.5 C 9.5 1.94772 9.05228 1.5 8.5 1.5 H 4 Z' stroke-linecap='round'/%3E%3C/g%3E%3Cg transform='matrix(33.3333 0 0 33.3333 216.6666 -216.6668)'%3E%3Cpath style='stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; is-custom-font: none; font-file-url: none; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;' transform=' translate(-18.5, -5.5)' d='M 20 1.5 C 21.3807 1.5 22.5 2.61929 22.5 4 V 8.5 C 22.5 9.05228 22.0523 9.5 21.5 9.5 H 20.5 C 19.9477 9.5 19.5 9.05228 19.5 8.5 V 4.5 H 15.5 C 14.9477 4.5 14.5 4.05228 14.5 3.5 V 2.5 C 14.5 1.94772 14.9477 1.5 15.5 1.5 H 20 Z' stroke-linecap='round'/%3E%3C/g%3E%3Cg transform='matrix(33.3333 0 0 33.3333 216.6666 216.6666)'%3E%3Cpath style='stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; is-custom-font: none; font-file-url: none; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;' transform=' translate(-18.5, -18.5)' d='M 20 22.5 C 21.3807 22.5 22.5 21.3807 22.5 20 V 15.5 C 22.5 14.9477 22.0523 14.5 21.5 14.5 H 20.5 C 19.9477 14.5 19.5 14.9477 19.5 15.5 V 19.5 H 15.5 C 14.9477 19.5 14.5 19.9477 14.5 20.5 V 21.5 C 14.5 22.0523 14.9477 22.5 15.5 22.5 H 20 Z' stroke-linecap='round'/%3E%3C/g%3E%3Cg transform='matrix(33.3333 0 0 33.3333 -216.6668 216.6666)'%3E%3Cpath style='stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; is-custom-font: none; font-file-url: none; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;' transform=' translate(-5.5, -18.5)' d='M 1.5 20 C 1.5 21.3807 2.61929 22.5 4 22.5 H 8.5 C 9.05228 22.5 9.5 22.0523 9.5 21.5 V 20.5 C 9.5 19.9477 9.05228 19.5 8.5 19.5 H 4.5 V 15.5 C 4.5 14.9477 4.05228 14.5 3.5 14.5 H 2.5 C 1.94772 14.5 1.5 14.9477 1.5 15.5 V 20 Z' stroke-linecap='round'/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E") !important;
  background-color: white !important;
}

.leaflet-control-zoom-fullscreen_exit {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' version='1.1' width='1000' height='1000' viewBox='0 0 1000 1000' xml:space='preserve'%3E%3Cdesc%3ECreated with Fabric.js 3.5.0%3C/desc%3E%3Cdefs%3E%3C/defs%3E%3Crect x='0' y='0' width='100%25' height='100%25' fill='rgba(255,255,255,0)'/%3E%3Cg transform='matrix(1.431 0 0 1.431 499.9956 499.9956)' id='142615'%3E%3Cg style='' vector-effect='non-scaling-stroke'%3E%3Cg transform='matrix(33.3333 0 0 33.3333 -216.6668 -216.6668)'%3E%3Cpath style='stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; is-custom-font: none; font-file-url: none; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;' transform=' translate(-5.5, -5.5)' d='M 7 9.5 C 8.38071 9.5 9.5 8.38071 9.5 7 V 2.5 C 9.5 1.94772 9.05228 1.5 8.5 1.5 H 7.5 C 6.94772 1.5 6.5 1.94772 6.5 2.5 V 6.5 H 2.5 C 1.94772 6.5 1.5 6.94772 1.5 7.5 V 8.5 C 1.5 9.05228 1.94772 9.5 2.5 9.5 H 7 Z' stroke-linecap='round'/%3E%3C/g%3E%3Cg transform='matrix(33.3333 0 0 33.3333 216.6666 -216.6668)'%3E%3Cpath style='stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; is-custom-font: none; font-file-url: none; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;' transform=' translate(-18.5, -5.5)' d='M 17 9.5 C 15.6193 9.5 14.5 8.38071 14.5 7 V 2.5 C 14.5 1.94772 14.9477 1.5 15.5 1.5 H 16.5 C 17.0523 1.5 17.5 1.94772 17.5 2.5 V 6.5 H 21.5 C 22.0523 6.5 22.5 6.94772 22.5 7.5 V 8.5 C 22.5 9.05228 22.0523 9.5 21.5 9.5 H 17 Z' stroke-linecap='round'/%3E%3C/g%3E%3Cg transform='matrix(33.3333 0 0 33.3333 216.6666 216.6666)'%3E%3Cpath style='stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; is-custom-font: none; font-file-url: none; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;' transform=' translate(-18.5, -18.5)' d='M 17 14.5 C 15.6193 14.5 14.5 15.6193 14.5 17 V 21.5 C 14.5 22.0523 14.9477 22.5 15.5 22.5 H 16.5 C 17.0523 22.5 17.5 22.0523 17.5 21.5 V 17.5 H 21.5 C 22.0523 17.5 22.5 17.0523 22.5 16.5 V 15.5 C 22.5 14.9477 22.0523 14.5 21.5 14.5 H 17 Z' stroke-linecap='round'/%3E%3C/g%3E%3Cg transform='matrix(33.3333 0 0 33.3333 -216.6668 216.6666)'%3E%3Cpath style='stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; is-custom-font: none; font-file-url: none; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;' transform=' translate(-5.5, -18.5)' d='M 9.5 17 C 9.5 15.6193 8.38071 14.5 7 14.5 H 2.5 C 1.94772 14.5 1.5 14.9477 1.5 15.5 V 16.5 C 1.5 17.0523 1.94772 17.5 2.5 17.5 H 6.5 V 21.5 C 6.5 22.0523 6.94772 22.5 7.5 22.5 H 8.5 C 9.05228 22.5 9.5 22.0523 9.5 21.5 V 17 Z' stroke-linecap='round'/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E") !important;
  background-color: yellow !important;
}

.leaflet-control-scale-line {
  background-color: rgba(255, 255, 255, 0.95) !important;
}

.leaflet-control-zoom-in {
  margin-bottom: 7px !important;
}

.alertmessage {
  position: fixed;
  top: 10px;
  left: 50%;
  z-index: 4000000;
  -webkit-transform: translate(-50%, 0);
  -moz-transform: translate(-50%, 0);
  -o-transform: translate(-50%, 0);
  transform: translate(-50%, 0);
}

.flexcenter {
  justify-content: center;
  display: flex;
}

.slider {
  width: 98% !important;
}

.btn-nopadding {
  padding-left: 0.1rem !important;
  padding-right: 0.1rem !important;
}

.flex-form-group {
  display: flex !important;
}

.centerall {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}

</style>
